

//------------IP ADDRESS--------------//
export const GET_IP_ADDRESS = 'GET_IP_ADDRESS';
export const GET_IP_ADDRESS_SUCCESS = 'GET_IP_ADDRESS_SUCCESS';
export const GET_IP_ADDRESS_FAILURE = 'GET_IP_ADDRESS_FAILURE';

//------------AUTH ACTIONS--------------//
export const GET_USERS = 'GET_USERS';

export const REGISTER = 'REGISTER';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
// Employee sign-in blocked by the society geofence — distinct from a bad-
// credentials failure so the UI can offer a "retry with fresh GPS" flow.
export const LOGIN_GEOFENCE_BLOCKED = 'LOGIN_GEOFENCE_BLOCKED';

export const RELOGIN = 'RELOGIN';
export const RELOGIN_SUCCESS = 'RELOGIN_SUCCESS';
export const RELOGIN_FAILURE = 'RELOGIN_FAILURE';

export const SOCIETY_FORGOT_PASSWORD = 'SOCIETY_FORGOT_PASSWORD';
export const SOCIETY_FORGOT_PASSWORD_SUCCESS = 'SOCIETY_FORGOT_PASSWORD_SUCCESS';
export const SOCIETY_FORGOT_PASSWORD_FAILURE = 'SOCIETY_FORGOT_PASSWORD_FAILURE';

export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

// ADMIN LOGIN


export const ADMIN_REGISTER = 'ADMIN_REGISTER';
export const ADMIN_REGISTER_SUCCESS = 'ADMIN_REGISTER_SUCCESS';
export const ADMIN_REGISTER_FAILURE = 'ADMIN_REGISTER_FAILURE';

export const ADMIN_LOGIN = 'ADMIN_LOGIN';
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS';
export const ADMIN_LOGIN_FAILURE = 'ADMIN_LOGIN_FAILURE';

export const ADMIN_RELOGIN = 'ADMIN_RELOGIN';
export const ADMIN_RELOGIN_SUCCESS = 'ADMIN_RELOGIN_SUCCESS';
export const ADMIN_RELOGIN_FAILURE = 'ADMIN_RELOGIN_FAILURE';

export const ADMIN_FORGOT_PASSWORD = 'ADMIN_FORGOT_PASSWORD';
export const ADMIN_FORGOT_PASSWORD_SUCCESS = 'ADMIN_FORGOT_PASSWORD_SUCCESS';
export const ADMIN_FORGOT_PASSWORD_FAILURE = 'ADMIN_FORGOT_PASSWORD_FAILURE';

export const ADMIN_PASSWORD_RESET = 'ADMIN_PASSWORD_RESET';
export const ADMIN_PASSWORD_RESET_SUCCESS = 'ADMIN_PASSWORD_RESET_SUCCESS';
export const ADMIN_PASSWORD_RESET_FAILURE = 'ADMIN_PASSWORD_RESET_FAILURE';

export const ADMIN_LOGOUT = 'ADMIN_LOGOUT';
export const ADMIN_LOGOUT_SUCCESS = 'ADMIN_LOGOUT_SUCCESS';
export const ADMIN_LOGOUT_FAILURE = 'ADMIN_LOGOUT_FAILURE';




// ------SOCIETY CONTROLLER------------

// Community MANAGEMENT
// Community ACTIONS
export const CTRL_COMMUNITY_LIST = 'CTRL_COMMUNITY_LIST';
export const CTRL_COMMUNITY_LIST_SUCCESS = 'CTRL_COMMUNITY_LIST_SUCCESS';
export const CTRL_COMMUNITY_LIST_FAILURE = 'CTRL_COMMUNITY_LIST_FAILURE';

export const CTRL_CREATE_COMMUNITY = 'CTRL_CREATE_COMMUNITY';
export const CTRL_CREATE_COMMUNITY_SUCCESS = 'CTRL_CREATE_COMMUNITY_SUCCESS';
export const CTRL_CREATE_COMMUNITY_FAILURE = 'CTRL_CREATE_COMMUNITY_FAILURE';

export const CTRL_EDIT_COMMUNITY = 'CTRL_EDIT_COMMUNITY';
export const CTRL_EDIT_COMMUNITY_SUCCESS = 'CTRL_EDIT_COMMUNITY_SUCCESS';
export const CTRL_EDIT_COMMUNITY_FAILURE = 'CTRL_EDIT_COMMUNITY_FAILURE';

export const CTRL_GET_COMMUNITY = 'CTRL_GET_COMMUNITY';
export const CTRL_GET_COMMUNITY_SUCCESS = 'CTRL_GET_COMMUNITY_SUCCESS';
export const CTRL_GET_COMMUNITY_FAILURE = 'CTRL_GET_COMMUNITY_FAILURE';

export const CTRL_GET_COMMUNITY_DETAILS = 'CTRL_GET_COMMUNITY_DETAILS';
export const CTRL_GET_COMMUNITY_DETAILS_SUCCESS = 'CTRL_GET_COMMUNITY_DETAILS_SUCCESS';
export const CTRL_GET_COMMUNITY_DETAILS_FAILURE = 'CTRL_GET_COMMUNITY_DETAILS_FAILURE';

export const CTRL_DELETE_COMMUNITY = 'CTRL_DELETE_COMMUNITY';
export const CTRL_DELETE_COMMUNITY_SUCCESS = 'CTRL_DELETE_COMMUNITY_SUCCESS';
export const CTRL_DELETE_COMMUNITY_FAILURE = 'CTRL_DELETE_COMMUNITY_FAILURE';

// Brand ACTIONS
export const CTRL_BRAND_LIST = 'CTRL_BRAND_LIST';
export const CTRL_BRAND_LIST_SUCCESS = 'CTRL_BRAND_LIST_SUCCESS';
export const CTRL_BRAND_LIST_FAILURE = 'CTRL_BRAND_LIST_FAILURE';

export const CTRL_GET_BRAND = 'CTRL_GET_BRAND';
export const CTRL_GET_BRAND_SUCCESS = 'CTRL_GET_BRAND_SUCCESS';
export const CTRL_GET_BRAND_FAILURE = 'CTRL_GET_BRAND_FAILURE';

export const CTRL_CREATE_BRAND = 'CTRL_CREATE_BRAND';
export const CTRL_CREATE_BRAND_SUCCESS = 'CTRL_CREATE_BRAND_SUCCESS';
export const CTRL_CREATE_BRAND_FAILURE = 'CTRL_CREATE_BRAND_FAILURE';

export const CTRL_EDIT_BRAND = 'CTRL_EDIT_BRAND';
export const CTRL_EDIT_BRAND_SUCCESS = 'CTRL_EDIT_BRAND_SUCCESS';
export const CTRL_EDIT_BRAND_FAILURE = 'CTRL_EDIT_BRAND_FAILURE';

export const CTRL_DELETE_BRAND = 'CTRL_DELETE_BRAND';
export const CTRL_DELETE_BRAND_SUCCESS = 'CTRL_DELETE_BRAND_SUCCESS';
export const CTRL_DELETE_BRAND_FAILURE = 'CTRL_DELETE_BRAND_FAILURE';


// EMPLOYEE MANAGEMENT ACTIONS (cross-society directory)
export const CTRL_EMPLOYEE_LIST = 'CTRL_EMPLOYEE_LIST';
export const CTRL_EMPLOYEE_LIST_SUCCESS = 'CTRL_EMPLOYEE_LIST_SUCCESS';
export const CTRL_EMPLOYEE_LIST_FAILURE = 'CTRL_EMPLOYEE_LIST_FAILURE';

export const CTRL_SOCIETY_DROPDOWN = 'CTRL_SOCIETY_DROPDOWN';
export const CTRL_SOCIETY_DROPDOWN_SUCCESS = 'CTRL_SOCIETY_DROPDOWN_SUCCESS';
export const CTRL_SOCIETY_DROPDOWN_FAILURE = 'CTRL_SOCIETY_DROPDOWN_FAILURE';

export const CTRL_EMPLOYEE_DIRECTORY = 'CTRL_EMPLOYEE_DIRECTORY';
export const CTRL_EMPLOYEE_DIRECTORY_SUCCESS = 'CTRL_EMPLOYEE_DIRECTORY_SUCCESS';
export const CTRL_EMPLOYEE_DIRECTORY_FAILURE = 'CTRL_EMPLOYEE_DIRECTORY_FAILURE';

export const CTRL_EMPLOYEE_SOCIETIES = 'CTRL_EMPLOYEE_SOCIETIES';
export const CTRL_EMPLOYEE_SOCIETIES_SUCCESS = 'CTRL_EMPLOYEE_SOCIETIES_SUCCESS';
export const CTRL_EMPLOYEE_SOCIETIES_FAILURE = 'CTRL_EMPLOYEE_SOCIETIES_FAILURE';

export const CTRL_ASSIGN_EMPLOYEE_SOCIETY = 'CTRL_ASSIGN_EMPLOYEE_SOCIETY';
export const CTRL_ASSIGN_EMPLOYEE_SOCIETY_SUCCESS = 'CTRL_ASSIGN_EMPLOYEE_SOCIETY_SUCCESS';
export const CTRL_ASSIGN_EMPLOYEE_SOCIETY_FAILURE = 'CTRL_ASSIGN_EMPLOYEE_SOCIETY_FAILURE';

export const CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE = 'CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE';
export const CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_SUCCESS = 'CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_SUCCESS';
export const CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_FAILURE = 'CTRL_CHANGE_EMPLOYEE_SOCIETY_ROLE_FAILURE';

export const CTRL_EMPLOYEE_STATS = 'CTRL_EMPLOYEE_STATS';
export const CTRL_EMPLOYEE_STATS_SUCCESS = 'CTRL_EMPLOYEE_STATS_SUCCESS';
export const CTRL_EMPLOYEE_STATS_FAILURE = 'CTRL_EMPLOYEE_STATS_FAILURE';

export const CTRL_EMPLOYEE_DETAILS = 'CTRL_EMPLOYEE_DETAILS';
export const CTRL_EMPLOYEE_DETAILS_SUCCESS = 'CTRL_EMPLOYEE_DETAILS_SUCCESS';
export const CTRL_EMPLOYEE_DETAILS_FAILURE = 'CTRL_EMPLOYEE_DETAILS_FAILURE';

export const CTRL_CREATE_EMPLOYEE = 'CTRL_CREATE_EMPLOYEE';
export const CTRL_CREATE_EMPLOYEE_SUCCESS = 'CTRL_CREATE_EMPLOYEE_SUCCESS';
export const CTRL_CREATE_EMPLOYEE_FAILURE = 'CTRL_CREATE_EMPLOYEE_FAILURE';

export const CTRL_UPDATE_EMPLOYEE = 'CTRL_UPDATE_EMPLOYEE';
export const CTRL_UPDATE_EMPLOYEE_SUCCESS = 'CTRL_UPDATE_EMPLOYEE_SUCCESS';
export const CTRL_UPDATE_EMPLOYEE_FAILURE = 'CTRL_UPDATE_EMPLOYEE_FAILURE';

export const CTRL_DELETE_EMPLOYEE = 'CTRL_DELETE_EMPLOYEE';
export const CTRL_DELETE_EMPLOYEE_SUCCESS = 'CTRL_DELETE_EMPLOYEE_SUCCESS';
export const CTRL_DELETE_EMPLOYEE_FAILURE = 'CTRL_DELETE_EMPLOYEE_FAILURE';

export const CTRL_BULK_STATUS_EMPLOYEE = 'CTRL_BULK_STATUS_EMPLOYEE';
export const CTRL_BULK_STATUS_EMPLOYEE_SUCCESS = 'CTRL_BULK_STATUS_EMPLOYEE_SUCCESS';
export const CTRL_BULK_STATUS_EMPLOYEE_FAILURE = 'CTRL_BULK_STATUS_EMPLOYEE_FAILURE';

export const CTRL_BULK_REASSIGN_EMPLOYEE = 'CTRL_BULK_REASSIGN_EMPLOYEE';
export const CTRL_BULK_REASSIGN_EMPLOYEE_SUCCESS = 'CTRL_BULK_REASSIGN_EMPLOYEE_SUCCESS';
export const CTRL_BULK_REASSIGN_EMPLOYEE_FAILURE = 'CTRL_BULK_REASSIGN_EMPLOYEE_FAILURE';

export const CTRL_SEARCH_EMPLOYEE_BY_EMAIL = 'CTRL_SEARCH_EMPLOYEE_BY_EMAIL';
export const CTRL_SEARCH_EMPLOYEE_BY_EMAIL_SUCCESS = 'CTRL_SEARCH_EMPLOYEE_BY_EMAIL_SUCCESS';
export const CTRL_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE = 'CTRL_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE';
export const CTRL_CLEAR_EMPLOYEE_SEARCH = 'CTRL_CLEAR_EMPLOYEE_SEARCH';

export const CTRL_LINK_EXISTING_EMPLOYEE = 'CTRL_LINK_EXISTING_EMPLOYEE';
export const CTRL_LINK_EXISTING_EMPLOYEE_SUCCESS = 'CTRL_LINK_EXISTING_EMPLOYEE_SUCCESS';
export const CTRL_LINK_EXISTING_EMPLOYEE_FAILURE = 'CTRL_LINK_EXISTING_EMPLOYEE_FAILURE';

export const CTRL_EMPLOYEE_TYPES_DROPDOWN = 'CTRL_EMPLOYEE_TYPES_DROPDOWN';
export const CTRL_EMPLOYEE_TYPES_DROPDOWN_SUCCESS = 'CTRL_EMPLOYEE_TYPES_DROPDOWN_SUCCESS';
export const CTRL_EMPLOYEE_TYPES_DROPDOWN_FAILURE = 'CTRL_EMPLOYEE_TYPES_DROPDOWN_FAILURE';

// DEFAULT (SYSTEM) ROLES & PERMISSIONS ACTIONS (super-admin)
export const CTRL_SYS_ROLE_LIST = 'CTRL_SYS_ROLE_LIST';
export const CTRL_SYS_ROLE_LIST_SUCCESS = 'CTRL_SYS_ROLE_LIST_SUCCESS';
export const CTRL_SYS_ROLE_LIST_FAILURE = 'CTRL_SYS_ROLE_LIST_FAILURE';

export const CTRL_SYS_ROLE_DETAILS = 'CTRL_SYS_ROLE_DETAILS';
export const CTRL_SYS_ROLE_DETAILS_SUCCESS = 'CTRL_SYS_ROLE_DETAILS_SUCCESS';
export const CTRL_SYS_ROLE_DETAILS_FAILURE = 'CTRL_SYS_ROLE_DETAILS_FAILURE';

export const CTRL_SYS_PERMISSION_CATALOG = 'CTRL_SYS_PERMISSION_CATALOG';
export const CTRL_SYS_PERMISSION_CATALOG_SUCCESS = 'CTRL_SYS_PERMISSION_CATALOG_SUCCESS';
export const CTRL_SYS_PERMISSION_CATALOG_FAILURE = 'CTRL_SYS_PERMISSION_CATALOG_FAILURE';

export const CTRL_SYS_ROLE_CREATE = 'CTRL_SYS_ROLE_CREATE';
export const CTRL_SYS_ROLE_CREATE_SUCCESS = 'CTRL_SYS_ROLE_CREATE_SUCCESS';
export const CTRL_SYS_ROLE_CREATE_FAILURE = 'CTRL_SYS_ROLE_CREATE_FAILURE';

export const CTRL_SYS_ROLE_UPDATE = 'CTRL_SYS_ROLE_UPDATE';
export const CTRL_SYS_ROLE_UPDATE_SUCCESS = 'CTRL_SYS_ROLE_UPDATE_SUCCESS';
export const CTRL_SYS_ROLE_UPDATE_FAILURE = 'CTRL_SYS_ROLE_UPDATE_FAILURE';

export const CTRL_SYS_ROLE_SET_PERMISSIONS = 'CTRL_SYS_ROLE_SET_PERMISSIONS';
export const CTRL_SYS_ROLE_SET_PERMISSIONS_SUCCESS = 'CTRL_SYS_ROLE_SET_PERMISSIONS_SUCCESS';
export const CTRL_SYS_ROLE_SET_PERMISSIONS_FAILURE = 'CTRL_SYS_ROLE_SET_PERMISSIONS_FAILURE';

export const CTRL_SYS_ROLE_DEACTIVATE = 'CTRL_SYS_ROLE_DEACTIVATE';
export const CTRL_SYS_ROLE_DEACTIVATE_SUCCESS = 'CTRL_SYS_ROLE_DEACTIVATE_SUCCESS';
export const CTRL_SYS_ROLE_DEACTIVATE_FAILURE = 'CTRL_SYS_ROLE_DEACTIVATE_FAILURE';

// EMPLOYEE TYPES (roles) CATALOG ACTIONS
export const CTRL_EMPLOYEE_ROLE_LIST = 'CTRL_EMPLOYEE_ROLE_LIST';
export const CTRL_EMPLOYEE_ROLE_LIST_SUCCESS = 'CTRL_EMPLOYEE_ROLE_LIST_SUCCESS';
export const CTRL_EMPLOYEE_ROLE_LIST_FAILURE = 'CTRL_EMPLOYEE_ROLE_LIST_FAILURE';

export const CTRL_EMPLOYEE_ROLE_DETAILS = 'CTRL_EMPLOYEE_ROLE_DETAILS';
export const CTRL_EMPLOYEE_ROLE_DETAILS_SUCCESS = 'CTRL_EMPLOYEE_ROLE_DETAILS_SUCCESS';
export const CTRL_EMPLOYEE_ROLE_DETAILS_FAILURE = 'CTRL_EMPLOYEE_ROLE_DETAILS_FAILURE';

export const CTRL_CREATE_EMPLOYEE_ROLE = 'CTRL_CREATE_EMPLOYEE_ROLE';
export const CTRL_CREATE_EMPLOYEE_ROLE_SUCCESS = 'CTRL_CREATE_EMPLOYEE_ROLE_SUCCESS';
export const CTRL_CREATE_EMPLOYEE_ROLE_FAILURE = 'CTRL_CREATE_EMPLOYEE_ROLE_FAILURE';

export const CTRL_UPDATE_EMPLOYEE_ROLE = 'CTRL_UPDATE_EMPLOYEE_ROLE';
export const CTRL_UPDATE_EMPLOYEE_ROLE_SUCCESS = 'CTRL_UPDATE_EMPLOYEE_ROLE_SUCCESS';
export const CTRL_UPDATE_EMPLOYEE_ROLE_FAILURE = 'CTRL_UPDATE_EMPLOYEE_ROLE_FAILURE';

export const CTRL_DELETE_EMPLOYEE_ROLE = 'CTRL_DELETE_EMPLOYEE_ROLE';
export const CTRL_DELETE_EMPLOYEE_ROLE_SUCCESS = 'CTRL_DELETE_EMPLOYEE_ROLE_SUCCESS';
export const CTRL_DELETE_EMPLOYEE_ROLE_FAILURE = 'CTRL_DELETE_EMPLOYEE_ROLE_FAILURE';


// LOCATION  ACTIONS
// COUNTRY ACTIONS
export const CTRL_CREATE_COUNTRY = 'CTRL_CREATE_COUNTRY';
export const CTRL_CREATE_COUNTRY_SUCCESS = 'CTRL_CREATE_COUNTRY_SUCCESS';
export const CTRL_CREATE_COUNTRY_FAILURE = 'CTRL_CREATE_COUNTRY_FAILURE';

export const CTRL_EDIT_COUNTRY = 'CTRL_EDIT_COUNTRY';
export const CTRL_EDIT_COUNTRY_SUCCESS = 'CTRL_EDIT_COUNTRY_SUCCESS';
export const CTRL_EDIT_COUNTRY_FAILURE = 'CTRL_EDIT_COUNTRY_FAILURE';

export const CTRL_GET_COUNTRY = 'CTRL_GET_COUNTRY';
export const CTRL_GET_COUNTRY_SUCCESS = 'CTRL_GET_COUNTRY_SUCCESS';
export const CTRL_GET_COUNTRY_FAILURE = 'CTRL_GET_COUNTRY_FAILURE';

export const CTRL_GET_COUNTRY_DETAILS = 'CTRL_GET_COUNTRY_DETAILS';
export const CTRL_GET_COUNTRY_DETAILS_SUCCESS = 'CTRL_GET_COUNTRY_DETAILS_SUCCESS';
export const CTRL_GET_COUNTRY_DETAILS_FAILURE = 'CTRL_GET_COUNTRY_DETAILS_FAILURE';

export const CTRL_DELETE_COUNTRY = 'CTRL_DELETE_COUNTRY';
export const CTRL_DELETE_COUNTRY_SUCCESS = 'CTRL_DELETE_COUNTRY_SUCCESS';
export const CTRL_DELETE_COUNTRY_FAILURE = 'CTRL_DELETE_COUNTRY_FAILURE';

// STATE ACTIONS
export const CTRL_CREATE_STATE = 'CTRL_CREATE_STATE';
export const CTRL_CREATE_STATE_SUCCESS = 'CTRL_CREATE_STATE_SUCCESS';
export const CTRL_CREATE_STATE_FAILURE = 'CTRL_CREATE_STATE_FAILURE';

export const CTRL_EDIT_STATE = 'CTRL_EDIT_STATE';
export const CTRL_EDIT_STATE_SUCCESS = 'CTRL_EDIT_STATE_SUCCESS';
export const CTRL_EDIT_STATE_FAILURE = 'CTRL_EDIT_STATE_FAILURE';

export const CTRL_GET_STATE = 'CTRL_GET_STATE';
export const CTRL_GET_STATE_SUCCESS = 'CTRL_GET_STATE_SUCCESS';
export const CTRL_GET_STATE_FAILURE = 'CTRL_GET_STATE_FAILURE';

export const CTRL_GET_STATE_DETAILS = 'CTRL_GET_STATE_DETAILS';
export const CTRL_GET_STATE_DETAILS_SUCCESS = 'CTRL_GET_STATE_DETAILS_SUCCESS';
export const CTRL_GET_STATE_DETAILS_FAILURE = 'CTRL_GET_STATE_DETAILS_FAILURE';

export const CTRL_DELETE_STATE = 'CTRL_DELETE_STATE';
export const CTRL_DELETE_STATE_SUCCESS = 'CTRL_DELETE_STATE_SUCCESS';
export const CTRL_DELETE_STATE_FAILURE = 'CTRL_DELETE_STATE_FAILURE';


// CITY ACTIONS
export const CTRL_CREATE_CITY = 'CTRL_CREATE_CITY';
export const CTRL_CREATE_CITY_SUCCESS = 'CTRL_CREATE_CITY_SUCCESS';
export const CTRL_CREATE_CITY_FAILURE = 'CTRL_CREATE_CITY_FAILURE';

export const CTRL_EDIT_CITY = 'CTRL_EDIT_CITY';
export const CTRL_EDIT_CITY_SUCCESS = 'CTRL_EDIT_CITY_SUCCESS';
export const CTRL_EDIT_CITY_FAILURE = 'CTRL_EDIT_CITY_FAILURE';

export const CTRL_GET_CITY = 'CTRL_GET_CITY';
export const CTRL_GET_CITY_SUCCESS = 'CTRL_GET_CITY_SUCCESS';
export const CTRL_GET_CITY_FAILURE = 'CTRL_GET_CITY_FAILURE';

export const CTRL_GET_CITY_DETAILS = 'CTRL_GET_CITY_DETAILS';
export const CTRL_GET_CITY_DETAILS_SUCCESS = 'CTRL_GET_CITY_DETAILS_SUCCESS';
export const CTRL_GET_CITY_DETAILS_FAILURE = 'CTRL_GET_CITY_DETAILS_FAILURE';

export const CTRL_DELETE_CITY = 'CTRL_DELETE_CITY';
export const CTRL_DELETE_CITY_SUCCESS = 'CTRL_DELETE_CITY_SUCCESS';
export const CTRL_DELETE_CITY_FAILURE = 'CTRL_DELETE_CITY_FAILURE';


// Profile Actions
export const CTRL_GET_PROFILE = 'CTRL_GET_PROFILE';
export const CTRL_GET_PROFILE_SUCCESS = 'CTRL_GET_PROFILE_SUCCESS';
export const CTRL_GET_PROFILE_FAILURE = 'CTRL_GET_PROFILE_FAILURE';

export const CTRL_UPDATE_PROFILE = 'CTRL_UPDATE_PROFILE';
export const CTRL_UPDATE_PROFILE_SUCCESS = 'CTRL_UPDATE_PROFILE_SUCCESS';
export const CTRL_UPDATE_PROFILE_FAILURE = 'CTRL_UPDATE_PROFILE_FAILURE';

export const CTRL_CHANGE_PASSWORD = 'CTRL_CHANGE_PASSWORD';
export const CTRL_CHANGE_PASSWORD_SUCCESS = 'CTRL_CHANGE_PASSWORD_SUCCESS';
export const CTRL_CHANGE_PASSWORD_FAILURE = 'CTRL_CHANGE_PASSWORD_FAILURE';


// SOCIETY PORTAL

// Invoice Type Actions
export const GET_INVOICE_TYPES = 'GET_INVOICE_TYPES';
export const GET_INVOICE_TYPES_SUCCESS = 'GET_INVOICE_TYPES_SUCCESS';
export const GET_INVOICE_TYPES_FAILURE = 'GET_INVOICE_TYPES_FAILURE';

export const GET_INVOICE_TYPE_DETAILS = 'GET_INVOICE_TYPE_DETAILS';
export const GET_INVOICE_TYPE_DETAILS_SUCCESS = 'GET_INVOICE_TYPE_DETAILS_SUCCESS';
export const GET_INVOICE_TYPE_DETAILS_FAILURE = 'GET_INVOICE_TYPE_DETAILS_FAILURE';

export const CREATE_INVOICE_TYPE = 'CREATE_INVOICE_TYPE';
export const CREATE_INVOICE_TYPE_SUCCESS = 'CREATE_INVOICE_TYPE_SUCCESS';
export const CREATE_INVOICE_TYPE_FAILURE = 'CREATE_INVOICE_TYPE_FAILURE';

export const UPDATE_INVOICE_TYPE = 'UPDATE_INVOICE_TYPE';
export const UPDATE_INVOICE_TYPE_SUCCESS = 'UPDATE_INVOICE_TYPE_SUCCESS';
export const UPDATE_INVOICE_TYPE_FAILURE = 'UPDATE_INVOICE_TYPE_FAILURE';

export const DELETE_INVOICE_TYPE = 'DELETE_INVOICE_TYPE';
export const DELETE_INVOICE_TYPE_SUCCESS = 'DELETE_INVOICE_TYPE_SUCCESS';
export const DELETE_INVOICE_TYPE_FAILURE = 'DELETE_INVOICE_TYPE_FAILURE';

// Invoice Settings Actions
export const GET_INVOICE_SETTINGS = 'GET_INVOICE_SETTINGS';
export const GET_INVOICE_SETTINGS_SUCCESS = 'GET_INVOICE_SETTINGS_SUCCESS';
export const GET_INVOICE_SETTINGS_FAILURE = 'GET_INVOICE_SETTINGS_FAILURE';

export const UPDATE_INVOICE_SETTINGS = 'UPDATE_INVOICE_SETTINGS';
export const UPDATE_INVOICE_SETTINGS_SUCCESS = 'UPDATE_INVOICE_SETTINGS_SUCCESS';
export const UPDATE_INVOICE_SETTINGS_FAILURE = 'UPDATE_INVOICE_SETTINGS_FAILURE';


// Document Series Actions
export const GET_DOCUMENT_SERIES = 'GET_DOCUMENT_SERIES';
export const GET_DOCUMENT_SERIES_SUCCESS = 'GET_DOCUMENT_SERIES_SUCCESS';
export const GET_DOCUMENT_SERIES_FAILURE = 'GET_DOCUMENT_SERIES_FAILURE';

export const GET_DOCUMENT_SERIES_DETAILS = 'GET_DOCUMENT_SERIES_DETAILS';
export const GET_DOCUMENT_SERIES_DETAILS_SUCCESS = 'GET_DOCUMENT_SERIES_DETAILS_SUCCESS';
export const GET_DOCUMENT_SERIES_DETAILS_FAILURE = 'GET_DOCUMENT_SERIES_DETAILS_FAILURE';

export const CREATE_DOCUMENT_SERIES = 'CREATE_DOCUMENT_SERIES';
export const CREATE_DOCUMENT_SERIES_SUCCESS = 'CREATE_DOCUMENT_SERIES_SUCCESS';
export const CREATE_DOCUMENT_SERIES_FAILURE = 'CREATE_DOCUMENT_SERIES_FAILURE';

export const UPDATE_DOCUMENT_SERIES = 'UPDATE_DOCUMENT_SERIES';
export const UPDATE_DOCUMENT_SERIES_SUCCESS = 'UPDATE_DOCUMENT_SERIES_SUCCESS';
export const UPDATE_DOCUMENT_SERIES_FAILURE = 'UPDATE_DOCUMENT_SERIES_FAILURE';

export const DELETE_DOCUMENT_SERIES = 'DELETE_DOCUMENT_SERIES';
export const DELETE_DOCUMENT_SERIES_SUCCESS = 'DELETE_DOCUMENT_SERIES_SUCCESS';
export const DELETE_DOCUMENT_SERIES_FAILURE = 'DELETE_DOCUMENT_SERIES_FAILURE';

export const PREVIEW_DOCUMENT_SERIES_NUMBER = 'PREVIEW_DOCUMENT_SERIES_NUMBER';
export const PREVIEW_DOCUMENT_SERIES_NUMBER_SUCCESS = 'PREVIEW_DOCUMENT_SERIES_NUMBER_SUCCESS';
export const PREVIEW_DOCUMENT_SERIES_NUMBER_FAILURE = 'PREVIEW_DOCUMENT_SERIES_NUMBER_FAILURE';
// ------------SOCIETY CONTROLLER--------------


// Society Profile Actions
export const GET_SOCIETY_PROFILE = 'GET_SOCIETY_PROFILE';
export const GET_SOCIETY_PROFILE_SUCCESS = 'GET_SOCIETY_PROFILE_SUCCESS';
export const GET_SOCIETY_PROFILE_FAILURE = 'GET_SOCIETY_PROFILE_FAILURE';

export const UPDATE_SOCIETY_PROFILE = 'UPDATE_SOCIETY_PROFILE';
export const UPDATE_SOCIETY_PROFILE_SUCCESS = 'UPDATE_SOCIETY_PROFILE_SUCCESS';
export const UPDATE_SOCIETY_PROFILE_FAILURE = 'UPDATE_SOCIETY_PROFILE_FAILURE';

export const CLEAR_SOCIETY_PROFILE = 'CLEAR_SOCIETY_PROFILE';

//------- SOCITY PORTAL-------------------

// Society
// Wings
export const SOCIETY_WINGS_LIST = 'SOCIETY_WINGS_LIST';
export const SOCIETY_WINGS_LIST_SUCCESS = 'SOCIETY_WINGS_LIST_SUCCESS';
export const SOCIETY_WINGS_LIST_FAILURE = 'SOCIETY_WINGS_LIST_FAILURE';

export const SOCIETY_CREATE_WINGS = 'SOCIETY_CREATE_WINGS';
export const SOCIETY_CREATE_WINGS_SUCCESS = 'SOCIETY_CREATE_WINGS_SUCCESS';
export const SOCIETY_CREATE_WINGS_FAILURE = 'SOCIETY_CREATE_WINGS_FAILURE';

export const SOCIETY_EDIT_WINGS = 'SOCIETY_EDIT_WINGS';
export const SOCIETY_EDIT_WINGS_SUCCESS = 'SOCIETY_EDIT_WINGS_SUCCESS';
export const SOCIETY_EDIT_WINGS_FAILURE = 'SOCIETY_EDIT_WINGS_FAILURE';

export const SOCIETY_DELETE_WINGS = 'SOCIETY_DELETE_WINGS';
export const SOCIETY_DELETE_WINGS_SUCCESS = 'SOCIETY_DELETE_WINGS_SUCCESS';
export const SOCIETY_DELETE_WINGS_FAILURE = 'SOCIETY_DELETE_WINGS_FAILURE';

// FLats
export const SOCIETY_FLATS_LIST = 'SOCIETY_FLATS_LIST';
export const SOCIETY_FLATS_LIST_SUCCESS = 'SOCIETY_FLATS_LIST_SUCCESS';
export const SOCIETY_FLATS_LIST_FAILURE = 'SOCIETY_FLATS_LIST_FAILURE';

// Wings & Flats Dropdown
export const SOCIETY_WINGS_DROPDOWN = 'SOCIETY_WINGS_DROPDOWN';
export const SOCIETY_WINGS_DROPDOWN_SUCCESS = 'SOCIETY_WINGS_DROPDOWN_SUCCESS';
export const SOCIETY_WINGS_DROPDOWN_FAILURE = 'SOCIETY_WINGS_DROPDOWN_FAILURE';
export const SOCIETY_FLATS_DROPDOWN = 'SOCIETY_FLATS_DROPDOWN';
export const SOCIETY_FLATS_DROPDOWN_SUCCESS = 'SOCIETY_FLATS_DROPDOWN_SUCCESS';
export const SOCIETY_FLATS_DROPDOWN_FAILURE = 'SOCIETY_FLATS_DROPDOWN_FAILURE';

// Flats With Ownership
export const SOCIETY_FLATS_WITH_OWNERSHIP = 'SOCIETY_FLATS_WITH_OWNERSHIP';
export const SOCIETY_FLATS_WITH_OWNERSHIP_SUCCESS = 'SOCIETY_FLATS_WITH_OWNERSHIP_SUCCESS';
export const SOCIETY_FLATS_WITH_OWNERSHIP_FAILURE = 'SOCIETY_FLATS_WITH_OWNERSHIP_FAILURE';

export const SOCIETY_CREATE_FLATS = 'SOCIETY_CREATE_FLATS';
export const SOCIETY_CREATE_FLATS_SUCCESS = 'SOCIETY_CREATE_FLATS_SUCCESS';
export const SOCIETY_CREATE_FLATS_FAILURE = 'SOCIETY_CREATE_FLATS_FAILURE';

export const SOCIETY_EDIT_FLATS = 'SOCIETY_EDIT_FLATS';
export const SOCIETY_EDIT_FLATS_SUCCESS = 'SOCIETY_EDIT_FLATS_SUCCESS';
export const SOCIETY_EDIT_FLATS_FAILURE = 'SOCIETY_EDIT_FLATS_FAILURE';

export const SOCIETY_DELETE_FLATS = 'SOCIETY_DELETE_FLATS';
export const SOCIETY_DELETE_FLATS_SUCCESS = 'SOCIETY_DELETE_FLATS_SUCCESS';
export const SOCIETY_DELETE_FLATS_FAILURE = 'SOCIETY_DELETE_FLATS_FAILURE';

export const SOCIETY_BULK_UPLOAD_WINGS = 'SOCIETY_BULK_UPLOAD_WINGS';
export const SOCIETY_BULK_UPLOAD_WINGS_SUCCESS = 'SOCIETY_BULK_UPLOAD_WINGS_SUCCESS';
export const SOCIETY_BULK_UPLOAD_WINGS_FAILURE = 'SOCIETY_BULK_UPLOAD_WINGS_FAILURE';
export const SOCIETY_CLEAR_WINGS_BULK_UPLOAD_STATE = 'SOCIETY_CLEAR_WINGS_BULK_UPLOAD_STATE';

export const SOCIETY_BULK_UPLOAD_FLATS = 'SOCIETY_BULK_UPLOAD_FLATS';
export const SOCIETY_BULK_UPLOAD_FLATS_SUCCESS = 'SOCIETY_BULK_UPLOAD_FLATS_SUCCESS';
export const SOCIETY_BULK_UPLOAD_FLATS_FAILURE = 'SOCIETY_BULK_UPLOAD_FLATS_FAILURE';
export const SOCIETY_CLEAR_FLATS_BULK_UPLOAD_STATE = 'SOCIETY_CLEAR_FLATS_BULK_UPLOAD_STATE';

// Tariff Heads (Charge Heads) Actions
export const GET_TARIFF_HEADS = 'GET_TARIFF_HEADS';
export const GET_TARIFF_HEADS_SUCCESS = 'GET_TARIFF_HEADS_SUCCESS';
export const GET_TARIFF_HEADS_FAILURE = 'GET_TARIFF_HEADS_FAILURE';

export const GET_TARIFF_HEADS_WITH_DETAILS = 'GET_TARIFF_HEADS_WITH_DETAILS';
export const GET_TARIFF_HEADS_WITH_DETAILS_SUCCESS = 'GET_TARIFF_HEADS_WITH_DETAILS_SUCCESS';
export const GET_TARIFF_HEADS_WITH_DETAILS_FAILURE = 'GET_TARIFF_HEADS_WITH_DETAILS_FAILURE';

export const GET_TARIFF_HEAD_DETAILS = 'GET_TARIFF_HEAD_DETAILS';
export const GET_TARIFF_HEAD_DETAILS_SUCCESS = 'GET_TARIFF_HEAD_DETAILS_SUCCESS';
export const GET_TARIFF_HEAD_DETAILS_FAILURE = 'GET_TARIFF_HEAD_DETAILS_FAILURE';

export const CREATE_TARIFF_HEAD = 'CREATE_TARIFF_HEAD';
export const CREATE_TARIFF_HEAD_SUCCESS = 'CREATE_TARIFF_HEAD_SUCCESS';
export const CREATE_TARIFF_HEAD_FAILURE = 'CREATE_TARIFF_HEAD_FAILURE';

export const UPDATE_TARIFF_HEAD = 'UPDATE_TARIFF_HEAD';
export const UPDATE_TARIFF_HEAD_SUCCESS = 'UPDATE_TARIFF_HEAD_SUCCESS';
export const UPDATE_TARIFF_HEAD_FAILURE = 'UPDATE_TARIFF_HEAD_FAILURE';

export const UPDATE_TARIFF_HEAD_STATUS = 'UPDATE_TARIFF_HEAD_STATUS';
export const UPDATE_TARIFF_HEAD_STATUS_SUCCESS = 'UPDATE_TARIFF_HEAD_STATUS_SUCCESS';
export const UPDATE_TARIFF_HEAD_STATUS_FAILURE = 'UPDATE_TARIFF_HEAD_STATUS_FAILURE';

export const DELETE_TARIFF_HEAD = 'DELETE_TARIFF_HEAD';
export const DELETE_TARIFF_HEAD_SUCCESS = 'DELETE_TARIFF_HEAD_SUCCESS';
export const DELETE_TARIFF_HEAD_FAILURE = 'DELETE_TARIFF_HEAD_FAILURE';

// Society Countries
export const SOCIETY_GET_COUNTRIES = 'SOCIETY_GET_COUNTRIES';
export const SOCIETY_GET_COUNTRIES_SUCCESS = 'SOCIETY_GET_COUNTRIES_SUCCESS';
export const SOCIETY_GET_COUNTRIES_FAILURE = 'SOCIETY_GET_COUNTRIES_FAILURE';

// Society States
export const SOCIETY_GET_STATES = 'SOCIETY_GET_STATES';
export const SOCIETY_GET_STATES_SUCCESS = 'SOCIETY_GET_STATES_SUCCESS';
export const SOCIETY_GET_STATES_FAILURE = 'SOCIETY_GET_STATES_FAILURE';

// Society Cities
export const SOCIETY_GET_CITIES = 'SOCIETY_GET_CITIES';
export const SOCIETY_GET_CITIES_SUCCESS = 'SOCIETY_GET_CITIES_SUCCESS';
export const SOCIETY_GET_CITIES_FAILURE = 'SOCIETY_GET_CITIES_FAILURE';

// Vendor Categories
export const SOCIETY_GET_VENDOR_CATEGORIES = 'SOCIETY_GET_VENDOR_CATEGORIES';
export const SOCIETY_GET_VENDOR_CATEGORIES_SUCCESS = 'SOCIETY_GET_VENDOR_CATEGORIES_SUCCESS';
export const SOCIETY_GET_VENDOR_CATEGORIES_FAILURE = 'SOCIETY_GET_VENDOR_CATEGORIES_FAILURE';

// Create Vendor
export const SOCIETY_CREATE_VENDOR = 'SOCIETY_CREATE_VENDOR';
export const SOCIETY_CREATE_VENDOR_SUCCESS = 'SOCIETY_CREATE_VENDOR_SUCCESS';
export const SOCIETY_CREATE_VENDOR_FAILURE = 'SOCIETY_CREATE_VENDOR_FAILURE';

// Vendor Excel bulk upload — dispatch payload carries the File; the saga
// posts multipart/form-data and stashes the { created, failed } summary in
// state so the results modal can render it.
export const SOCIETY_BULK_UPLOAD_VENDORS = 'SOCIETY_BULK_UPLOAD_VENDORS';
export const SOCIETY_BULK_UPLOAD_VENDORS_SUCCESS = 'SOCIETY_BULK_UPLOAD_VENDORS_SUCCESS';
export const SOCIETY_BULK_UPLOAD_VENDORS_FAILURE = 'SOCIETY_BULK_UPLOAD_VENDORS_FAILURE';
export const SOCIETY_BULK_UPLOAD_VENDORS_RESET = 'SOCIETY_BULK_UPLOAD_VENDORS_RESET';

// Vendor Bill Excel bulk upload — same pattern as vendors above.
export const SOCIETY_BULK_UPLOAD_VENDOR_BILLS = 'SOCIETY_BULK_UPLOAD_VENDOR_BILLS';
export const SOCIETY_BULK_UPLOAD_VENDOR_BILLS_SUCCESS = 'SOCIETY_BULK_UPLOAD_VENDOR_BILLS_SUCCESS';
export const SOCIETY_BULK_UPLOAD_VENDOR_BILLS_FAILURE = 'SOCIETY_BULK_UPLOAD_VENDOR_BILLS_FAILURE';
export const SOCIETY_BULK_UPLOAD_VENDOR_BILLS_RESET = 'SOCIETY_BULK_UPLOAD_VENDOR_BILLS_RESET';

// Vendor Payment Excel bulk upload — same pattern.
export const SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS = 'SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS';
export const SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_SUCCESS = 'SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_SUCCESS';
export const SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_FAILURE = 'SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_FAILURE';
export const SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_RESET = 'SOCIETY_BULK_UPLOAD_VENDOR_PAYMENTS_RESET';

// Get Vendor Details
export const SOCIETY_GET_VENDOR_DETAILS = 'SOCIETY_GET_VENDOR_DETAILS';
export const SOCIETY_GET_VENDOR_DETAILS_SUCCESS = 'SOCIETY_GET_VENDOR_DETAILS_SUCCESS';
export const SOCIETY_GET_VENDOR_DETAILS_FAILURE = 'SOCIETY_GET_VENDOR_DETAILS_FAILURE';

// Get Vendors List
export const SOCIETY_GET_VENDORS_LIST = 'SOCIETY_GET_VENDORS_LIST';
export const SOCIETY_GET_VENDORS_LIST_SUCCESS = 'SOCIETY_GET_VENDORS_LIST_SUCCESS';
export const SOCIETY_GET_VENDORS_LIST_FAILURE = 'SOCIETY_GET_VENDORS_LIST_FAILURE';

// Update Vendor
export const SOCIETY_UPDATE_VENDOR = 'SOCIETY_UPDATE_VENDOR';
export const SOCIETY_UPDATE_VENDOR_SUCCESS = 'SOCIETY_UPDATE_VENDOR_SUCCESS';
export const SOCIETY_UPDATE_VENDOR_FAILURE = 'SOCIETY_UPDATE_VENDOR_FAILURE';

// Delete Vendor
export const SOCIETY_DELETE_VENDOR = 'SOCIETY_DELETE_VENDOR';
export const SOCIETY_DELETE_VENDOR_SUCCESS = 'SOCIETY_DELETE_VENDOR_SUCCESS';
export const SOCIETY_DELETE_VENDOR_FAILURE = 'SOCIETY_DELETE_VENDOR_FAILURE';

// Get All Vendors (for dropdowns)
export const SOCIETY_GET_ALL_VENDORS = 'SOCIETY_GET_ALL_VENDORS';
export const SOCIETY_GET_ALL_VENDORS_SUCCESS = 'SOCIETY_GET_ALL_VENDORS_SUCCESS';
export const SOCIETY_GET_ALL_VENDORS_FAILURE = 'SOCIETY_GET_ALL_VENDORS_FAILURE';

// ============ VENDOR TARIFFS ============

// Get Vendor Tariffs
export const SOCIETY_GET_VENDOR_TARIFFS = 'SOCIETY_GET_VENDOR_TARIFFS';
export const SOCIETY_GET_VENDOR_TARIFFS_SUCCESS = 'SOCIETY_GET_VENDOR_TARIFFS_SUCCESS';
export const SOCIETY_GET_VENDOR_TARIFFS_FAILURE = 'SOCIETY_GET_VENDOR_TARIFFS_FAILURE';

// Get All Vendor Tariffs
export const SOCIETY_GET_ALL_VENDOR_TARIFFS = 'SOCIETY_GET_ALL_VENDOR_TARIFFS';
export const SOCIETY_GET_ALL_VENDOR_TARIFFS_SUCCESS = 'SOCIETY_GET_ALL_VENDOR_TARIFFS_SUCCESS';
export const SOCIETY_GET_ALL_VENDOR_TARIFFS_FAILURE = 'SOCIETY_GET_ALL_VENDOR_TARIFFS_FAILURE';

// Create Vendor Tariff
export const SOCIETY_CREATE_VENDOR_TARIFF = 'SOCIETY_CREATE_VENDOR_TARIFF';
export const SOCIETY_CREATE_VENDOR_TARIFF_SUCCESS = 'SOCIETY_CREATE_VENDOR_TARIFF_SUCCESS';
export const SOCIETY_CREATE_VENDOR_TARIFF_FAILURE = 'SOCIETY_CREATE_VENDOR_TARIFF_FAILURE';

// Delete Vendor Tariff
export const SOCIETY_DELETE_VENDOR_TARIFF = 'SOCIETY_DELETE_VENDOR_TARIFF';
export const SOCIETY_DELETE_VENDOR_TARIFF_SUCCESS = 'SOCIETY_DELETE_VENDOR_TARIFF_SUCCESS';
export const SOCIETY_DELETE_VENDOR_TARIFF_FAILURE = 'SOCIETY_DELETE_VENDOR_TARIFF_FAILURE';

// ============ VENDOR BILLS ============

// Get Vendor Bills List
export const SOCIETY_GET_VENDOR_BILLS_LIST = 'SOCIETY_GET_VENDOR_BILLS_LIST';
export const SOCIETY_GET_VENDOR_BILLS_LIST_SUCCESS = 'SOCIETY_GET_VENDOR_BILLS_LIST_SUCCESS';
export const SOCIETY_GET_VENDOR_BILLS_LIST_FAILURE = 'SOCIETY_GET_VENDOR_BILLS_LIST_FAILURE';

// Get Vendor Bill Details
export const SOCIETY_GET_VENDOR_BILL_DETAILS = 'SOCIETY_GET_VENDOR_BILL_DETAILS';
export const SOCIETY_GET_VENDOR_BILL_DETAILS_SUCCESS = 'SOCIETY_GET_VENDOR_BILL_DETAILS_SUCCESS';
export const SOCIETY_GET_VENDOR_BILL_DETAILS_FAILURE = 'SOCIETY_GET_VENDOR_BILL_DETAILS_FAILURE';

// Create Vendor Bill
export const SOCIETY_CREATE_VENDOR_BILL = 'SOCIETY_CREATE_VENDOR_BILL';
export const SOCIETY_CREATE_VENDOR_BILL_SUCCESS = 'SOCIETY_CREATE_VENDOR_BILL_SUCCESS';
export const SOCIETY_CREATE_VENDOR_BILL_FAILURE = 'SOCIETY_CREATE_VENDOR_BILL_FAILURE';
export const SOCIETY_CREATE_VENDOR_BILLS_BATCH = 'SOCIETY_CREATE_VENDOR_BILLS_BATCH';
export const SOCIETY_CREATE_VENDOR_BILLS_BATCH_SUCCESS = 'SOCIETY_CREATE_VENDOR_BILLS_BATCH_SUCCESS';
export const SOCIETY_CREATE_VENDOR_BILLS_BATCH_FAILURE = 'SOCIETY_CREATE_VENDOR_BILLS_BATCH_FAILURE';
export const SOCIETY_CREATE_VENDOR_BILLS_BATCH_RESET = 'SOCIETY_CREATE_VENDOR_BILLS_BATCH_RESET';

// Update Vendor Bill
export const SOCIETY_UPDATE_VENDOR_BILL = 'SOCIETY_UPDATE_VENDOR_BILL';
export const SOCIETY_UPDATE_VENDOR_BILL_SUCCESS = 'SOCIETY_UPDATE_VENDOR_BILL_SUCCESS';
export const SOCIETY_UPDATE_VENDOR_BILL_FAILURE = 'SOCIETY_UPDATE_VENDOR_BILL_FAILURE';

// Delete Vendor Bill
export const SOCIETY_DELETE_VENDOR_BILL = 'SOCIETY_DELETE_VENDOR_BILL';
export const SOCIETY_DELETE_VENDOR_BILL_SUCCESS = 'SOCIETY_DELETE_VENDOR_BILL_SUCCESS';
export const SOCIETY_DELETE_VENDOR_BILL_FAILURE = 'SOCIETY_DELETE_VENDOR_BILL_FAILURE';

// Approve Vendor Bill
export const SOCIETY_APPROVE_VENDOR_BILL = 'SOCIETY_APPROVE_VENDOR_BILL';
export const SOCIETY_APPROVE_VENDOR_BILL_SUCCESS = 'SOCIETY_APPROVE_VENDOR_BILL_SUCCESS';
export const SOCIETY_APPROVE_VENDOR_BILL_FAILURE = 'SOCIETY_APPROVE_VENDOR_BILL_FAILURE';

// Pay Vendor Bill
export const SOCIETY_PAY_VENDOR_BILL = 'SOCIETY_PAY_VENDOR_BILL';
export const SOCIETY_PAY_VENDOR_BILL_SUCCESS = 'SOCIETY_PAY_VENDOR_BILL_SUCCESS';
export const SOCIETY_PAY_VENDOR_BILL_FAILURE = 'SOCIETY_PAY_VENDOR_BILL_FAILURE';

// Create Vendor Category
export const SOCIETY_CREATE_VENDOR_CATEGORY = 'SOCIETY_CREATE_VENDOR_CATEGORY';
export const SOCIETY_CREATE_VENDOR_CATEGORY_SUCCESS = 'SOCIETY_CREATE_VENDOR_CATEGORY_SUCCESS';
export const SOCIETY_CREATE_VENDOR_CATEGORY_FAILURE = 'SOCIETY_CREATE_VENDOR_CATEGORY_FAILURE';

// Update Vendor Category
export const SOCIETY_UPDATE_VENDOR_CATEGORY = 'SOCIETY_UPDATE_VENDOR_CATEGORY';
export const SOCIETY_UPDATE_VENDOR_CATEGORY_SUCCESS = 'SOCIETY_UPDATE_VENDOR_CATEGORY_SUCCESS';
export const SOCIETY_UPDATE_VENDOR_CATEGORY_FAILURE = 'SOCIETY_UPDATE_VENDOR_CATEGORY_FAILURE';

// Delete Vendor Category
export const SOCIETY_DELETE_VENDOR_CATEGORY = 'SOCIETY_DELETE_VENDOR_CATEGORY';
export const SOCIETY_DELETE_VENDOR_CATEGORY_SUCCESS = 'SOCIETY_DELETE_VENDOR_CATEGORY_SUCCESS';
export const SOCIETY_DELETE_VENDOR_CATEGORY_FAILURE = 'SOCIETY_DELETE_VENDOR_CATEGORY_FAILURE';

// Get Vendor Setting
export const SOCIETY_GET_VENDOR_SETTING = 'SOCIETY_GET_VENDOR_SETTING';
export const SOCIETY_GET_VENDOR_SETTING_SUCCESS = 'SOCIETY_GET_VENDOR_SETTING_SUCCESS';
export const SOCIETY_GET_VENDOR_SETTING_FAILURE = 'SOCIETY_GET_VENDOR_SETTING_FAILURE';

// Vendor Bank Accounts
export const SOCIETY_GET_VENDOR_BANK_ACCOUNTS = 'SOCIETY_GET_VENDOR_BANK_ACCOUNTS';
export const SOCIETY_GET_VENDOR_BANK_ACCOUNTS_SUCCESS = 'SOCIETY_GET_VENDOR_BANK_ACCOUNTS_SUCCESS';
export const SOCIETY_GET_VENDOR_BANK_ACCOUNTS_FAILURE = 'SOCIETY_GET_VENDOR_BANK_ACCOUNTS_FAILURE';

export const SOCIETY_CREATE_VENDOR_BANK_ACCOUNT = 'SOCIETY_CREATE_VENDOR_BANK_ACCOUNT';
export const SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_SUCCESS = 'SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_SUCCESS';
export const SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_FAILURE = 'SOCIETY_CREATE_VENDOR_BANK_ACCOUNT_FAILURE';

export const SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT = 'SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT';
export const SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_SUCCESS = 'SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_SUCCESS';
export const SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_FAILURE = 'SOCIETY_UPDATE_VENDOR_BANK_ACCOUNT_FAILURE';

export const SOCIETY_DELETE_VENDOR_BANK_ACCOUNT = 'SOCIETY_DELETE_VENDOR_BANK_ACCOUNT';
export const SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_SUCCESS = 'SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_SUCCESS';
export const SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_FAILURE = 'SOCIETY_DELETE_VENDOR_BANK_ACCOUNT_FAILURE';

// Vendor AMC Tracker
export const SOCIETY_GET_VENDOR_AMC_LIST = 'SOCIETY_GET_VENDOR_AMC_LIST';
export const SOCIETY_GET_VENDOR_AMC_LIST_SUCCESS = 'SOCIETY_GET_VENDOR_AMC_LIST_SUCCESS';
export const SOCIETY_GET_VENDOR_AMC_LIST_FAILURE = 'SOCIETY_GET_VENDOR_AMC_LIST_FAILURE';

export const SOCIETY_GET_VENDOR_AMC_DETAILS = 'SOCIETY_GET_VENDOR_AMC_DETAILS';
export const SOCIETY_GET_VENDOR_AMC_DETAILS_SUCCESS = 'SOCIETY_GET_VENDOR_AMC_DETAILS_SUCCESS';
export const SOCIETY_GET_VENDOR_AMC_DETAILS_FAILURE = 'SOCIETY_GET_VENDOR_AMC_DETAILS_FAILURE';

export const SOCIETY_CREATE_VENDOR_AMC = 'SOCIETY_CREATE_VENDOR_AMC';
export const SOCIETY_CREATE_VENDOR_AMC_SUCCESS = 'SOCIETY_CREATE_VENDOR_AMC_SUCCESS';
export const SOCIETY_CREATE_VENDOR_AMC_FAILURE = 'SOCIETY_CREATE_VENDOR_AMC_FAILURE';

export const SOCIETY_UPDATE_VENDOR_AMC = 'SOCIETY_UPDATE_VENDOR_AMC';
export const SOCIETY_UPDATE_VENDOR_AMC_SUCCESS = 'SOCIETY_UPDATE_VENDOR_AMC_SUCCESS';
export const SOCIETY_UPDATE_VENDOR_AMC_FAILURE = 'SOCIETY_UPDATE_VENDOR_AMC_FAILURE';

export const SOCIETY_DELETE_VENDOR_AMC = 'SOCIETY_DELETE_VENDOR_AMC';
export const SOCIETY_DELETE_VENDOR_AMC_SUCCESS = 'SOCIETY_DELETE_VENDOR_AMC_SUCCESS';
export const SOCIETY_DELETE_VENDOR_AMC_FAILURE = 'SOCIETY_DELETE_VENDOR_AMC_FAILURE';

// Vendor GL Codes
export const SOCIETY_GET_VENDOR_GL_CODES = 'SOCIETY_GET_VENDOR_GL_CODES';
export const SOCIETY_GET_VENDOR_GL_CODES_SUCCESS = 'SOCIETY_GET_VENDOR_GL_CODES_SUCCESS';
export const SOCIETY_GET_VENDOR_GL_CODES_FAILURE = 'SOCIETY_GET_VENDOR_GL_CODES_FAILURE';

// Vendor GL Code Dropdown
export const SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN = 'SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN';
export const SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_SUCCESS = 'SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_SUCCESS';
export const SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_FAILURE = 'SOCIETY_GET_VENDOR_GL_CODE_DROPDOWN_FAILURE';

// Vendor Round Off GL Code
export const SOCIETY_GET_VENDOR_ROUND_OFF_GL = 'SOCIETY_GET_VENDOR_ROUND_OFF_GL';
export const SOCIETY_GET_VENDOR_ROUND_OFF_GL_SUCCESS = 'SOCIETY_GET_VENDOR_ROUND_OFF_GL_SUCCESS';
export const SOCIETY_GET_VENDOR_ROUND_OFF_GL_FAILURE = 'SOCIETY_GET_VENDOR_ROUND_OFF_GL_FAILURE';

// ============ VENDOR PAYMENTS ============

// Get Vendor Payments List
export const SOCIETY_GET_VENDOR_PAYMENTS_LIST = 'SOCIETY_GET_VENDOR_PAYMENTS_LIST';
export const SOCIETY_GET_VENDOR_PAYMENTS_LIST_SUCCESS = 'SOCIETY_GET_VENDOR_PAYMENTS_LIST_SUCCESS';
export const SOCIETY_GET_VENDOR_PAYMENTS_LIST_FAILURE = 'SOCIETY_GET_VENDOR_PAYMENTS_LIST_FAILURE';

// Get Vendor Payment Details
export const SOCIETY_GET_VENDOR_PAYMENT_DETAILS = 'SOCIETY_GET_VENDOR_PAYMENT_DETAILS';
export const SOCIETY_GET_VENDOR_PAYMENT_DETAILS_SUCCESS = 'SOCIETY_GET_VENDOR_PAYMENT_DETAILS_SUCCESS';
export const SOCIETY_GET_VENDOR_PAYMENT_DETAILS_FAILURE = 'SOCIETY_GET_VENDOR_PAYMENT_DETAILS_FAILURE';

// Create Vendor Payment
export const SOCIETY_CREATE_VENDOR_PAYMENT = 'SOCIETY_CREATE_VENDOR_PAYMENT';
export const SOCIETY_CREATE_VENDOR_PAYMENT_SUCCESS = 'SOCIETY_CREATE_VENDOR_PAYMENT_SUCCESS';
export const SOCIETY_CREATE_VENDOR_PAYMENT_FAILURE = 'SOCIETY_CREATE_VENDOR_PAYMENT_FAILURE';

// Update Vendor Payment
export const SOCIETY_UPDATE_VENDOR_PAYMENT = 'SOCIETY_UPDATE_VENDOR_PAYMENT';
export const SOCIETY_UPDATE_VENDOR_PAYMENT_SUCCESS = 'SOCIETY_UPDATE_VENDOR_PAYMENT_SUCCESS';
export const SOCIETY_UPDATE_VENDOR_PAYMENT_FAILURE = 'SOCIETY_UPDATE_VENDOR_PAYMENT_FAILURE';

// Delete Vendor Payment
export const SOCIETY_DELETE_VENDOR_PAYMENT = 'SOCIETY_DELETE_VENDOR_PAYMENT';
export const SOCIETY_DELETE_VENDOR_PAYMENT_SUCCESS = 'SOCIETY_DELETE_VENDOR_PAYMENT_SUCCESS';
export const SOCIETY_DELETE_VENDOR_PAYMENT_FAILURE = 'SOCIETY_DELETE_VENDOR_PAYMENT_FAILURE';

// Get Vendor Unpaid Bills
export const SOCIETY_GET_VENDOR_UNPAID_BILLS = 'SOCIETY_GET_VENDOR_UNPAID_BILLS';
export const SOCIETY_GET_VENDOR_UNPAID_BILLS_SUCCESS = 'SOCIETY_GET_VENDOR_UNPAID_BILLS_SUCCESS';
export const SOCIETY_GET_VENDOR_UNPAID_BILLS_FAILURE = 'SOCIETY_GET_VENDOR_UNPAID_BILLS_FAILURE';

export const SOCIETY_SAVE_VENDOR_BILLING_SETTINGS = 'SOCIETY_SAVE_VENDOR_BILLING_SETTINGS';
export const SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_SUCCESS = 'SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_SUCCESS';
export const SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_FAILURE = 'SOCIETY_SAVE_VENDOR_BILLING_SETTINGS_FAILURE';

export const SOCIETY_GET_VENDOR_BILLING_SETTINGS = 'SOCIETY_GET_VENDOR_BILLING_SETTINGS';
export const SOCIETY_GET_VENDOR_BILLING_SETTINGS_SUCCESS = 'SOCIETY_GET_VENDOR_BILLING_SETTINGS_SUCCESS';
export const SOCIETY_GET_VENDOR_BILLING_SETTINGS_FAILURE = 'SOCIETY_GET_VENDOR_BILLING_SETTINGS_FAILURE';

// Tariff Rates Actions
export const GET_TARIFF_RATES = 'GET_TARIFF_RATES';
export const GET_TARIFF_RATES_SUCCESS = 'GET_TARIFF_RATES_SUCCESS';
export const GET_TARIFF_RATES_FAILURE = 'GET_TARIFF_RATES_FAILURE';

export const GET_TARIFF_RATES_BY_HEAD = 'GET_TARIFF_RATES_BY_HEAD';
export const GET_TARIFF_RATES_BY_HEAD_SUCCESS = 'GET_TARIFF_RATES_BY_HEAD_SUCCESS';
export const GET_TARIFF_RATES_BY_HEAD_FAILURE = 'GET_TARIFF_RATES_BY_HEAD_FAILURE';

export const GET_TARIFF_RATE_DETAILS = 'GET_TARIFF_RATE_DETAILS';
export const GET_TARIFF_RATE_DETAILS_SUCCESS = 'GET_TARIFF_RATE_DETAILS_SUCCESS';
export const GET_TARIFF_RATE_DETAILS_FAILURE = 'GET_TARIFF_RATE_DETAILS_FAILURE';

export const CREATE_TARIFF_RATE = 'CREATE_TARIFF_RATE';
export const CREATE_TARIFF_RATE_SUCCESS = 'CREATE_TARIFF_RATE_SUCCESS';
export const CREATE_TARIFF_RATE_FAILURE = 'CREATE_TARIFF_RATE_FAILURE';

export const UPDATE_TARIFF_RATE = 'UPDATE_TARIFF_RATE';
export const UPDATE_TARIFF_RATE_SUCCESS = 'UPDATE_TARIFF_RATE_SUCCESS';
export const UPDATE_TARIFF_RATE_FAILURE = 'UPDATE_TARIFF_RATE_FAILURE';

export const UPDATE_TARIFF_RATE_STATUS = 'UPDATE_TARIFF_RATE_STATUS';
export const UPDATE_TARIFF_RATE_STATUS_SUCCESS = 'UPDATE_TARIFF_RATE_STATUS_SUCCESS';
export const UPDATE_TARIFF_RATE_STATUS_FAILURE = 'UPDATE_TARIFF_RATE_STATUS_FAILURE';

export const DELETE_TARIFF_RATE = 'DELETE_TARIFF_RATE';
export const DELETE_TARIFF_RATE_SUCCESS = 'DELETE_TARIFF_RATE_SUCCESS';
export const DELETE_TARIFF_RATE_FAILURE = 'DELETE_TARIFF_RATE_FAILURE';

// Invoice Actions
export const GET_INVOICES = 'GET_INVOICES';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAILURE = 'GET_INVOICES_FAILURE';

export const GET_INVOICE_DETAILS = 'GET_INVOICE_DETAILS';
export const GET_INVOICE_DETAILS_SUCCESS = 'GET_INVOICE_DETAILS_SUCCESS';
export const GET_INVOICE_DETAILS_FAILURE = 'GET_INVOICE_DETAILS_FAILURE';

export const GET_INVOICE_STATISTICS = 'GET_INVOICE_STATISTICS';
export const GET_INVOICE_STATISTICS_SUCCESS = 'GET_INVOICE_STATISTICS_SUCCESS';
export const GET_INVOICE_STATISTICS_FAILURE = 'GET_INVOICE_STATISTICS_FAILURE';

export const GET_INVOICES_BY_FLAT = 'GET_INVOICES_BY_FLAT';
export const GET_INVOICES_BY_FLAT_SUCCESS = 'GET_INVOICES_BY_FLAT_SUCCESS';
export const GET_INVOICES_BY_FLAT_FAILURE = 'GET_INVOICES_BY_FLAT_FAILURE';

export const GET_UNPAID_INVOICES_BY_FLAT = 'GET_UNPAID_INVOICES_BY_FLAT';
export const GET_UNPAID_INVOICES_BY_FLAT_SUCCESS = 'GET_UNPAID_INVOICES_BY_FLAT_SUCCESS';
export const GET_UNPAID_INVOICES_BY_FLAT_FAILURE = 'GET_UNPAID_INVOICES_BY_FLAT_FAILURE';

export const CREATE_INVOICE = 'CREATE_INVOICE';
export const CREATE_INVOICE_SUCCESS = 'CREATE_INVOICE_SUCCESS';
export const CREATE_INVOICE_FAILURE = 'CREATE_INVOICE_FAILURE';

export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const UPDATE_INVOICE_SUCCESS = 'UPDATE_INVOICE_SUCCESS';
export const UPDATE_INVOICE_FAILURE = 'UPDATE_INVOICE_FAILURE';

export const UPDATE_DRAFT_INVOICE = 'UPDATE_DRAFT_INVOICE';
export const UPDATE_DRAFT_INVOICE_SUCCESS = 'UPDATE_DRAFT_INVOICE_SUCCESS';
export const UPDATE_DRAFT_INVOICE_FAILURE = 'UPDATE_DRAFT_INVOICE_FAILURE';

export const DELETE_INVOICE = 'DELETE_INVOICE';
export const DELETE_INVOICE_SUCCESS = 'DELETE_INVOICE_SUCCESS';
export const DELETE_INVOICE_FAILURE = 'DELETE_INVOICE_FAILURE';

export const VOID_INVOICE = 'VOID_INVOICE';
export const VOID_INVOICE_SUCCESS = 'VOID_INVOICE_SUCCESS';
export const VOID_INVOICE_FAILURE = 'VOID_INVOICE_FAILURE';

export const POST_INVOICE = 'POST_INVOICE';
export const POST_INVOICE_SUCCESS = 'POST_INVOICE_SUCCESS';
export const POST_INVOICE_FAILURE = 'POST_INVOICE_FAILURE';

export const CLEAR_INVOICE_STATE = 'CLEAR_INVOICE_STATE';

// Bulk Invoice Actions
export const BULK_INVOICE_DETAILS = 'BULK_INVOICE_DETAILS';
export const BULK_INVOICE_DETAILS_SUCCESS = 'BULK_INVOICE_DETAILS_SUCCESS';
export const BULK_INVOICE_DETAILS_FAILURE = 'BULK_INVOICE_DETAILS_FAILURE';

export const BULK_POST_INVOICES = 'BULK_POST_INVOICES';
export const BULK_POST_INVOICES_SUCCESS = 'BULK_POST_INVOICES_SUCCESS';
export const BULK_POST_INVOICES_FAILURE = 'BULK_POST_INVOICES_FAILURE';

export const BULK_DELETE_INVOICES = 'BULK_DELETE_INVOICES';
export const BULK_DELETE_INVOICES_SUCCESS = 'BULK_DELETE_INVOICES_SUCCESS';
export const BULK_DELETE_INVOICES_FAILURE = 'BULK_DELETE_INVOICES_FAILURE';

export const BULK_PREVIEW_INVOICES = 'BULK_PREVIEW_INVOICES';
export const BULK_PREVIEW_INVOICES_SUCCESS = 'BULK_PREVIEW_INVOICES_SUCCESS';
export const BULK_PREVIEW_INVOICES_FAILURE = 'BULK_PREVIEW_INVOICES_FAILURE';

export const BULK_CREATE_INVOICES = 'BULK_CREATE_INVOICES';
export const BULK_CREATE_INVOICES_SUCCESS = 'BULK_CREATE_INVOICES_SUCCESS';
export const BULK_CREATE_INVOICES_FAILURE = 'BULK_CREATE_INVOICES_FAILURE';

// Arrears Actions
export const GET_ARREARS_BY_FLAT = 'GET_ARREARS_BY_FLAT';
export const GET_ARREARS_BY_FLAT_SUCCESS = 'GET_ARREARS_BY_FLAT_SUCCESS';
export const GET_ARREARS_BY_FLAT_FAILURE = 'GET_ARREARS_BY_FLAT_FAILURE';

// Occupant Actions
export const GET_OCCUPANTS = 'GET_OCCUPANTS';
export const GET_OCCUPANTS_SUCCESS = 'GET_OCCUPANTS_SUCCESS';
export const GET_OCCUPANTS_FAILURE = 'GET_OCCUPANTS_FAILURE';

export const GET_OCCUPANT_DETAILS = 'GET_OCCUPANT_DETAILS';
export const GET_OCCUPANT_DETAILS_SUCCESS = 'GET_OCCUPANT_DETAILS_SUCCESS';
export const GET_OCCUPANT_DETAILS_FAILURE = 'GET_OCCUPANT_DETAILS_FAILURE';

export const CREATE_OCCUPANT = 'CREATE_OCCUPANT';
export const CREATE_OCCUPANT_SUCCESS = 'CREATE_OCCUPANT_SUCCESS';
export const CREATE_OCCUPANT_FAILURE = 'CREATE_OCCUPANT_FAILURE';

export const UPDATE_OCCUPANT = 'UPDATE_OCCUPANT';
export const UPDATE_OCCUPANT_SUCCESS = 'UPDATE_OCCUPANT_SUCCESS';
export const UPDATE_OCCUPANT_FAILURE = 'UPDATE_OCCUPANT_FAILURE';

export const DELETE_OCCUPANT = 'DELETE_OCCUPANT';
export const DELETE_OCCUPANT_SUCCESS = 'DELETE_OCCUPANT_SUCCESS';
export const DELETE_OCCUPANT_FAILURE = 'DELETE_OCCUPANT_FAILURE';

// Occupant documents (Police NOC, Rental Agreement / Leave & License, other)
export const UPLOAD_OCCUPANT_DOCUMENT = 'UPLOAD_OCCUPANT_DOCUMENT';
export const UPLOAD_OCCUPANT_DOCUMENT_SUCCESS = 'UPLOAD_OCCUPANT_DOCUMENT_SUCCESS';
export const UPLOAD_OCCUPANT_DOCUMENT_FAILURE = 'UPLOAD_OCCUPANT_DOCUMENT_FAILURE';

export const DELETE_OCCUPANT_DOCUMENT = 'DELETE_OCCUPANT_DOCUMENT';
export const DELETE_OCCUPANT_DOCUMENT_SUCCESS = 'DELETE_OCCUPANT_DOCUMENT_SUCCESS';
export const DELETE_OCCUPANT_DOCUMENT_FAILURE = 'DELETE_OCCUPANT_DOCUMENT_FAILURE';

export const LIST_OCCUPANT_DOCUMENTS = 'LIST_OCCUPANT_DOCUMENTS';
export const LIST_OCCUPANT_DOCUMENTS_SUCCESS = 'LIST_OCCUPANT_DOCUMENTS_SUCCESS';
export const LIST_OCCUPANT_DOCUMENTS_FAILURE = 'LIST_OCCUPANT_DOCUMENTS_FAILURE';

// Meter Reading Actions
export const GET_METER_READINGS = 'GET_METER_READINGS';
export const GET_METER_READINGS_SUCCESS = 'GET_METER_READINGS_SUCCESS';
export const GET_METER_READINGS_FAILURE = 'GET_METER_READINGS_FAILURE';

export const GET_METER_READING_DETAILS = 'GET_METER_READING_DETAILS';
export const GET_METER_READING_DETAILS_SUCCESS = 'GET_METER_READING_DETAILS_SUCCESS';
export const GET_METER_READING_DETAILS_FAILURE = 'GET_METER_READING_DETAILS_FAILURE';

export const GET_LAST_METER_READING = 'GET_LAST_METER_READING';
export const GET_LAST_METER_READING_SUCCESS = 'GET_LAST_METER_READING_SUCCESS';
export const GET_LAST_METER_READING_FAILURE = 'GET_LAST_METER_READING_FAILURE';

export const CREATE_METER_READING = 'CREATE_METER_READING';
export const CREATE_METER_READING_SUCCESS = 'CREATE_METER_READING_SUCCESS';
export const CREATE_METER_READING_FAILURE = 'CREATE_METER_READING_FAILURE';

export const CREATE_BULK_METER_READINGS = 'CREATE_BULK_METER_READINGS';
export const CREATE_BULK_METER_READINGS_SUCCESS = 'CREATE_BULK_METER_READINGS_SUCCESS';
export const CREATE_BULK_METER_READINGS_FAILURE = 'CREATE_BULK_METER_READINGS_FAILURE';

export const UPLOAD_METER_READINGS = 'UPLOAD_METER_READINGS';
export const UPLOAD_METER_READINGS_SUCCESS = 'UPLOAD_METER_READINGS_SUCCESS';
export const UPLOAD_METER_READINGS_FAILURE = 'UPLOAD_METER_READINGS_FAILURE';

export const DOWNLOAD_METER_READING_TEMPLATE = 'DOWNLOAD_METER_READING_TEMPLATE';
export const DOWNLOAD_METER_READING_TEMPLATE_SUCCESS = 'DOWNLOAD_METER_READING_TEMPLATE_SUCCESS';
export const DOWNLOAD_METER_READING_TEMPLATE_FAILURE = 'DOWNLOAD_METER_READING_TEMPLATE_FAILURE';

export const UPDATE_METER_READING = 'UPDATE_METER_READING';
export const UPDATE_METER_READING_SUCCESS = 'UPDATE_METER_READING_SUCCESS';
export const UPDATE_METER_READING_FAILURE = 'UPDATE_METER_READING_FAILURE';

export const DELETE_METER_READING = 'DELETE_METER_READING';
export const DELETE_METER_READING_SUCCESS = 'DELETE_METER_READING_SUCCESS';
export const DELETE_METER_READING_FAILURE = 'DELETE_METER_READING_FAILURE';

export const CLEAR_METER_READING_STATE = 'CLEAR_METER_READING_STATE';

// Meter Slab Actions
export const GET_METER_SLABS = 'GET_METER_SLABS';
export const GET_METER_SLABS_SUCCESS = 'GET_METER_SLABS_SUCCESS';
export const GET_METER_SLABS_FAILURE = 'GET_METER_SLABS_FAILURE';

export const GET_METER_SLABS_BY_HEAD = 'GET_METER_SLABS_BY_HEAD';
export const GET_METER_SLABS_BY_HEAD_SUCCESS = 'GET_METER_SLABS_BY_HEAD_SUCCESS';
export const GET_METER_SLABS_BY_HEAD_FAILURE = 'GET_METER_SLABS_BY_HEAD_FAILURE';

export const GET_METER_SLAB_DETAILS = 'GET_METER_SLAB_DETAILS';
export const GET_METER_SLAB_DETAILS_SUCCESS = 'GET_METER_SLAB_DETAILS_SUCCESS';
export const GET_METER_SLAB_DETAILS_FAILURE = 'GET_METER_SLAB_DETAILS_FAILURE';

export const CREATE_METER_SLAB = 'CREATE_METER_SLAB';
export const CREATE_METER_SLAB_SUCCESS = 'CREATE_METER_SLAB_SUCCESS';
export const CREATE_METER_SLAB_FAILURE = 'CREATE_METER_SLAB_FAILURE';

export const CREATE_BULK_METER_SLABS = 'CREATE_BULK_METER_SLABS';
export const CREATE_BULK_METER_SLABS_SUCCESS = 'CREATE_BULK_METER_SLABS_SUCCESS';
export const CREATE_BULK_METER_SLABS_FAILURE = 'CREATE_BULK_METER_SLABS_FAILURE';

export const UPDATE_METER_SLAB = 'UPDATE_METER_SLAB';
export const UPDATE_METER_SLAB_SUCCESS = 'UPDATE_METER_SLAB_SUCCESS';
export const UPDATE_METER_SLAB_FAILURE = 'UPDATE_METER_SLAB_FAILURE';

export const UPDATE_METER_SLAB_STATUS = 'UPDATE_METER_SLAB_STATUS';
export const UPDATE_METER_SLAB_STATUS_SUCCESS = 'UPDATE_METER_SLAB_STATUS_SUCCESS';
export const UPDATE_METER_SLAB_STATUS_FAILURE = 'UPDATE_METER_SLAB_STATUS_FAILURE';

export const DELETE_METER_SLAB = 'DELETE_METER_SLAB';
export const DELETE_METER_SLAB_SUCCESS = 'DELETE_METER_SLAB_SUCCESS';
export const DELETE_METER_SLAB_FAILURE = 'DELETE_METER_SLAB_FAILURE';

export const CLEAR_METER_SLAB_STATE = 'CLEAR_METER_SLAB_STATE';

// Journal Actions
export const GET_JOURNALS = 'GET_JOURNALS';
export const GET_JOURNALS_SUCCESS = 'GET_JOURNALS_SUCCESS';
export const GET_JOURNALS_FAILURE = 'GET_JOURNALS_FAILURE';

export const GET_JOURNAL_DETAILS = 'GET_JOURNAL_DETAILS';
export const GET_JOURNAL_DETAILS_SUCCESS = 'GET_JOURNAL_DETAILS_SUCCESS';
export const GET_JOURNAL_DETAILS_FAILURE = 'GET_JOURNAL_DETAILS_FAILURE';

export const CREATE_JOURNAL = 'CREATE_JOURNAL';
export const CREATE_JOURNAL_SUCCESS = 'CREATE_JOURNAL_SUCCESS';
export const CREATE_JOURNAL_FAILURE = 'CREATE_JOURNAL_FAILURE';

export const UPDATE_JOURNAL = 'UPDATE_JOURNAL';
export const UPDATE_JOURNAL_SUCCESS = 'UPDATE_JOURNAL_SUCCESS';
export const UPDATE_JOURNAL_FAILURE = 'UPDATE_JOURNAL_FAILURE';

export const DELETE_JOURNAL = 'DELETE_JOURNAL';
export const DELETE_JOURNAL_SUCCESS = 'DELETE_JOURNAL_SUCCESS';
export const DELETE_JOURNAL_FAILURE = 'DELETE_JOURNAL_FAILURE';

export const CLEAR_JOURNAL_STATE = 'CLEAR_JOURNAL_STATE';
export const CLEAR_JOURNAL_DETAILS = 'CLEAR_JOURNAL_DETAILS';
export const CLEAR_JOURNAL_AUDIT_LOGS = 'CLEAR_JOURNAL_AUDIT_LOGS';

export const GET_ACCOUNT_HEADS = 'GET_ACCOUNT_HEADS';
export const GET_ACCOUNT_HEADS_SUCCESS = 'GET_ACCOUNT_HEADS_SUCCESS';
export const GET_ACCOUNT_HEADS_FAILURE = 'GET_ACCOUNT_HEADS_FAILURE';

export const GET_JOURNAL_AUDIT_LOGS = 'GET_JOURNAL_AUDIT_LOGS';
export const GET_JOURNAL_AUDIT_LOGS_SUCCESS = 'GET_JOURNAL_AUDIT_LOGS_SUCCESS';
export const GET_JOURNAL_AUDIT_LOGS_FAILURE = 'GET_JOURNAL_AUDIT_LOGS_FAILURE';

export const BULK_VALIDATE_JOURNALS = 'BULK_VALIDATE_JOURNALS';
export const BULK_VALIDATE_JOURNALS_SUCCESS = 'BULK_VALIDATE_JOURNALS_SUCCESS';
export const BULK_VALIDATE_JOURNALS_FAILURE = 'BULK_VALIDATE_JOURNALS_FAILURE';

export const BULK_UPLOAD_JOURNALS = 'BULK_UPLOAD_JOURNALS';
export const BULK_UPLOAD_JOURNALS_SUCCESS = 'BULK_UPLOAD_JOURNALS_SUCCESS';
export const BULK_UPLOAD_JOURNALS_FAILURE = 'BULK_UPLOAD_JOURNALS_FAILURE';

export const CLEAR_BULK_IMPORT_STATE = 'CLEAR_BULK_IMPORT_STATE';

// Opening Balance Actions
export const GET_OPENING_BALANCES = 'GET_OPENING_BALANCES';
export const GET_OPENING_BALANCES_SUCCESS = 'GET_OPENING_BALANCES_SUCCESS';
export const GET_OPENING_BALANCES_FAILURE = 'GET_OPENING_BALANCES_FAILURE';

export const CREATE_OPENING_BALANCE = 'CREATE_OPENING_BALANCE';
export const CREATE_OPENING_BALANCE_SUCCESS = 'CREATE_OPENING_BALANCE_SUCCESS';
export const CREATE_OPENING_BALANCE_FAILURE = 'CREATE_OPENING_BALANCE_FAILURE';

export const UPDATE_OPENING_BALANCE = 'UPDATE_OPENING_BALANCE';
export const UPDATE_OPENING_BALANCE_SUCCESS = 'UPDATE_OPENING_BALANCE_SUCCESS';
export const UPDATE_OPENING_BALANCE_FAILURE = 'UPDATE_OPENING_BALANCE_FAILURE';

export const DELETE_OPENING_BALANCE = 'DELETE_OPENING_BALANCE';
export const DELETE_OPENING_BALANCE_SUCCESS = 'DELETE_OPENING_BALANCE_SUCCESS';
export const DELETE_OPENING_BALANCE_FAILURE = 'DELETE_OPENING_BALANCE_FAILURE';

export const BULK_UPLOAD_OPENING_BALANCES = 'BULK_UPLOAD_OPENING_BALANCES';
export const BULK_UPLOAD_OPENING_BALANCES_SUCCESS = 'BULK_UPLOAD_OPENING_BALANCES_SUCCESS';
export const BULK_UPLOAD_OPENING_BALANCES_FAILURE = 'BULK_UPLOAD_OPENING_BALANCES_FAILURE';

// Credit/Debit Note Actions
export const GET_CREDIT_DEBIT_NOTES = 'GET_CREDIT_DEBIT_NOTES';
export const GET_CREDIT_DEBIT_NOTES_SUCCESS = 'GET_CREDIT_DEBIT_NOTES_SUCCESS';
export const GET_CREDIT_DEBIT_NOTES_FAILURE = 'GET_CREDIT_DEBIT_NOTES_FAILURE';

export const GET_CREDIT_DEBIT_NOTE_DETAILS = 'GET_CREDIT_DEBIT_NOTE_DETAILS';
export const GET_CREDIT_DEBIT_NOTE_DETAILS_SUCCESS = 'GET_CREDIT_DEBIT_NOTE_DETAILS_SUCCESS';
export const GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE = 'GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE';

export const GET_CREDIT_DEBIT_NOTES_BY_INVOICE = 'GET_CREDIT_DEBIT_NOTES_BY_INVOICE';
export const GET_CREDIT_DEBIT_NOTES_BY_INVOICE_SUCCESS = 'GET_CREDIT_DEBIT_NOTES_BY_INVOICE_SUCCESS';
export const GET_CREDIT_DEBIT_NOTES_BY_INVOICE_FAILURE = 'GET_CREDIT_DEBIT_NOTES_BY_INVOICE_FAILURE';

export const CREATE_CREDIT_DEBIT_NOTE = 'CREATE_CREDIT_DEBIT_NOTE';
export const CREATE_CREDIT_DEBIT_NOTE_SUCCESS = 'CREATE_CREDIT_DEBIT_NOTE_SUCCESS';
export const CREATE_CREDIT_DEBIT_NOTE_FAILURE = 'CREATE_CREDIT_DEBIT_NOTE_FAILURE';

export const UPDATE_CREDIT_DEBIT_NOTE = 'UPDATE_CREDIT_DEBIT_NOTE';
export const UPDATE_CREDIT_DEBIT_NOTE_SUCCESS = 'UPDATE_CREDIT_DEBIT_NOTE_SUCCESS';
export const UPDATE_CREDIT_DEBIT_NOTE_FAILURE = 'UPDATE_CREDIT_DEBIT_NOTE_FAILURE';

export const POST_CREDIT_DEBIT_NOTE = 'POST_CREDIT_DEBIT_NOTE';
export const POST_CREDIT_DEBIT_NOTE_SUCCESS = 'POST_CREDIT_DEBIT_NOTE_SUCCESS';
export const POST_CREDIT_DEBIT_NOTE_FAILURE = 'POST_CREDIT_DEBIT_NOTE_FAILURE';

export const VOID_CREDIT_DEBIT_NOTE = 'VOID_CREDIT_DEBIT_NOTE';
export const VOID_CREDIT_DEBIT_NOTE_SUCCESS = 'VOID_CREDIT_DEBIT_NOTE_SUCCESS';
export const VOID_CREDIT_DEBIT_NOTE_FAILURE = 'VOID_CREDIT_DEBIT_NOTE_FAILURE';

export const DELETE_CREDIT_DEBIT_NOTE = 'DELETE_CREDIT_DEBIT_NOTE';
export const DELETE_CREDIT_DEBIT_NOTE_SUCCESS = 'DELETE_CREDIT_DEBIT_NOTE_SUCCESS';
export const DELETE_CREDIT_DEBIT_NOTE_FAILURE = 'DELETE_CREDIT_DEBIT_NOTE_FAILURE';

export const CLEAR_CREDIT_DEBIT_NOTE_STATE = 'CLEAR_CREDIT_DEBIT_NOTE_STATE';

export const BULK_UPLOAD_CREDIT_DEBIT_NOTES = 'BULK_UPLOAD_CREDIT_DEBIT_NOTES';
export const BULK_UPLOAD_CREDIT_DEBIT_NOTES_SUCCESS = 'BULK_UPLOAD_CREDIT_DEBIT_NOTES_SUCCESS';
export const BULK_UPLOAD_CREDIT_DEBIT_NOTES_FAILURE = 'BULK_UPLOAD_CREDIT_DEBIT_NOTES_FAILURE';
export const CLEAR_CREDIT_DEBIT_NOTE_BULK_UPLOAD_STATE = 'CLEAR_CREDIT_DEBIT_NOTE_BULK_UPLOAD_STATE';

export const BULK_GET_CREDIT_DEBIT_NOTE_DETAILS = 'BULK_GET_CREDIT_DEBIT_NOTE_DETAILS';
export const BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_SUCCESS = 'BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_SUCCESS';
export const BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE = 'BULK_GET_CREDIT_DEBIT_NOTE_DETAILS_FAILURE';

export const BULK_POST_CREDIT_DEBIT_NOTES = 'BULK_POST_CREDIT_DEBIT_NOTES';
export const BULK_POST_CREDIT_DEBIT_NOTES_SUCCESS = 'BULK_POST_CREDIT_DEBIT_NOTES_SUCCESS';
export const BULK_POST_CREDIT_DEBIT_NOTES_FAILURE = 'BULK_POST_CREDIT_DEBIT_NOTES_FAILURE';

export const BULK_DELETE_CREDIT_DEBIT_NOTES = 'BULK_DELETE_CREDIT_DEBIT_NOTES';
export const BULK_DELETE_CREDIT_DEBIT_NOTES_SUCCESS = 'BULK_DELETE_CREDIT_DEBIT_NOTES_SUCCESS';
export const BULK_DELETE_CREDIT_DEBIT_NOTES_FAILURE = 'BULK_DELETE_CREDIT_DEBIT_NOTES_FAILURE';

// Receipt Actions
export const GET_RECEIPTS = 'GET_RECEIPTS';
export const GET_RECEIPTS_SUCCESS = 'GET_RECEIPTS_SUCCESS';
export const GET_RECEIPTS_FAILURE = 'GET_RECEIPTS_FAILURE';

export const GET_RECEIPT_DETAILS = 'GET_RECEIPT_DETAILS';
export const GET_RECEIPT_DETAILS_SUCCESS = 'GET_RECEIPT_DETAILS_SUCCESS';
export const GET_RECEIPT_DETAILS_FAILURE = 'GET_RECEIPT_DETAILS_FAILURE';

export const GET_RECEIPTS_BY_FLAT = 'GET_RECEIPTS_BY_FLAT';
export const GET_RECEIPTS_BY_FLAT_SUCCESS = 'GET_RECEIPTS_BY_FLAT_SUCCESS';
export const GET_RECEIPTS_BY_FLAT_FAILURE = 'GET_RECEIPTS_BY_FLAT_FAILURE';

export const CREATE_RECEIPT = 'CREATE_RECEIPT';
export const CREATE_RECEIPT_SUCCESS = 'CREATE_RECEIPT_SUCCESS';
export const CREATE_RECEIPT_FAILURE = 'CREATE_RECEIPT_FAILURE';

export const UPDATE_RECEIPT = 'UPDATE_RECEIPT';
export const UPDATE_RECEIPT_SUCCESS = 'UPDATE_RECEIPT_SUCCESS';
export const UPDATE_RECEIPT_FAILURE = 'UPDATE_RECEIPT_FAILURE';

export const DELETE_RECEIPT = 'DELETE_RECEIPT';
export const DELETE_RECEIPT_SUCCESS = 'DELETE_RECEIPT_SUCCESS';
export const DELETE_RECEIPT_FAILURE = 'DELETE_RECEIPT_FAILURE';

export const CLEAR_RECEIPT = 'CLEAR_RECEIPT';
export const CLEAR_RECEIPT_SUCCESS = 'CLEAR_RECEIPT_SUCCESS';
export const CLEAR_RECEIPT_FAILURE = 'CLEAR_RECEIPT_FAILURE';

export const BOUNCE_RECEIPT = 'BOUNCE_RECEIPT';
export const BOUNCE_RECEIPT_SUCCESS = 'BOUNCE_RECEIPT_SUCCESS';
export const BOUNCE_RECEIPT_FAILURE = 'BOUNCE_RECEIPT_FAILURE';

export const GET_OUTSTANDING_DOCUMENTS = 'GET_OUTSTANDING_DOCUMENTS';
export const GET_OUTSTANDING_DOCUMENTS_SUCCESS = 'GET_OUTSTANDING_DOCUMENTS_SUCCESS';
export const GET_OUTSTANDING_DOCUMENTS_FAILURE = 'GET_OUTSTANDING_DOCUMENTS_FAILURE';

export const CALCULATE_ALLOCATION_COMPONENTS = 'CALCULATE_ALLOCATION_COMPONENTS';
export const CALCULATE_ALLOCATION_COMPONENTS_SUCCESS = 'CALCULATE_ALLOCATION_COMPONENTS_SUCCESS';
export const CALCULATE_ALLOCATION_COMPONENTS_FAILURE = 'CALCULATE_ALLOCATION_COMPONENTS_FAILURE';

export const UPDATE_RECEIPT_ALLOCATIONS = 'UPDATE_RECEIPT_ALLOCATIONS';
export const UPDATE_RECEIPT_ALLOCATIONS_SUCCESS = 'UPDATE_RECEIPT_ALLOCATIONS_SUCCESS';
export const UPDATE_RECEIPT_ALLOCATIONS_FAILURE = 'UPDATE_RECEIPT_ALLOCATIONS_FAILURE';

export const CLEAR_RECEIPT_STATE = 'CLEAR_RECEIPT_STATE';

// Accounts Opening (Flat-level) Actions
export const GET_ACCOUNTS_OPENING = 'GET_ACCOUNTS_OPENING';
export const GET_ACCOUNTS_OPENING_SUCCESS = 'GET_ACCOUNTS_OPENING_SUCCESS';
export const GET_ACCOUNTS_OPENING_FAILURE = 'GET_ACCOUNTS_OPENING_FAILURE';

export const CREATE_ACCOUNTS_OPENING = 'CREATE_ACCOUNTS_OPENING';
export const CREATE_ACCOUNTS_OPENING_SUCCESS = 'CREATE_ACCOUNTS_OPENING_SUCCESS';
export const CREATE_ACCOUNTS_OPENING_FAILURE = 'CREATE_ACCOUNTS_OPENING_FAILURE';

export const UPDATE_ACCOUNTS_OPENING = 'UPDATE_ACCOUNTS_OPENING';
export const UPDATE_ACCOUNTS_OPENING_SUCCESS = 'UPDATE_ACCOUNTS_OPENING_SUCCESS';
export const UPDATE_ACCOUNTS_OPENING_FAILURE = 'UPDATE_ACCOUNTS_OPENING_FAILURE';

export const DELETE_ACCOUNTS_OPENING = 'DELETE_ACCOUNTS_OPENING';
export const DELETE_ACCOUNTS_OPENING_SUCCESS = 'DELETE_ACCOUNTS_OPENING_SUCCESS';
export const DELETE_ACCOUNTS_OPENING_FAILURE = 'DELETE_ACCOUNTS_OPENING_FAILURE';

export const DOWNLOAD_ACCOUNTS_OPENING = 'DOWNLOAD_ACCOUNTS_OPENING';
export const DOWNLOAD_ACCOUNTS_OPENING_SUCCESS = 'DOWNLOAD_ACCOUNTS_OPENING_SUCCESS';
export const DOWNLOAD_ACCOUNTS_OPENING_FAILURE = 'DOWNLOAD_ACCOUNTS_OPENING_FAILURE';

export const BULK_UPLOAD_ACCOUNTS_OPENING = 'BULK_UPLOAD_ACCOUNTS_OPENING';
export const BULK_UPLOAD_ACCOUNTS_OPENING_SUCCESS = 'BULK_UPLOAD_ACCOUNTS_OPENING_SUCCESS';
export const BULK_UPLOAD_ACCOUNTS_OPENING_FAILURE = 'BULK_UPLOAD_ACCOUNTS_OPENING_FAILURE';

export const GET_GL_ACCOUNTS_OPENING = 'GET_GL_ACCOUNTS_OPENING';
export const GET_GL_ACCOUNTS_OPENING_SUCCESS = 'GET_GL_ACCOUNTS_OPENING_SUCCESS';
export const GET_GL_ACCOUNTS_OPENING_FAILURE = 'GET_GL_ACCOUNTS_OPENING_FAILURE';

export const SAVE_GL_ACCOUNTS_OPENING = 'SAVE_GL_ACCOUNTS_OPENING';
export const SAVE_GL_ACCOUNTS_OPENING_SUCCESS = 'SAVE_GL_ACCOUNTS_OPENING_SUCCESS';
export const SAVE_GL_ACCOUNTS_OPENING_FAILURE = 'SAVE_GL_ACCOUNTS_OPENING_FAILURE';

export const CLEAR_ACCOUNTS_OPENING_STATE = 'CLEAR_ACCOUNTS_OPENING_STATE';

// Accounts Closing
export const GET_GL_ACCOUNTS_CLOSING = 'GET_GL_ACCOUNTS_CLOSING';
export const GET_GL_ACCOUNTS_CLOSING_SUCCESS = 'GET_GL_ACCOUNTS_CLOSING_SUCCESS';
export const GET_GL_ACCOUNTS_CLOSING_FAILURE = 'GET_GL_ACCOUNTS_CLOSING_FAILURE';

export const CREATE_ACCOUNTS_CLOSING = 'CREATE_ACCOUNTS_CLOSING';
export const CREATE_ACCOUNTS_CLOSING_SUCCESS = 'CREATE_ACCOUNTS_CLOSING_SUCCESS';
export const CREATE_ACCOUNTS_CLOSING_FAILURE = 'CREATE_ACCOUNTS_CLOSING_FAILURE';

export const CLEAR_ACCOUNTS_CLOSING_STATE = 'CLEAR_ACCOUNTS_CLOSING_STATE';

// Member Daybook
export const GET_MEMBER_DAYBOOK = 'GET_MEMBER_DAYBOOK';
export const GET_MEMBER_DAYBOOK_SUCCESS = 'GET_MEMBER_DAYBOOK_SUCCESS';
export const GET_MEMBER_DAYBOOK_FAILURE = 'GET_MEMBER_DAYBOOK_FAILURE';

export const CLEAR_MEMBER_DAYBOOK_STATE = 'CLEAR_MEMBER_DAYBOOK_STATE';

export const BULK_UPLOAD_RECEIPTS = 'BULK_UPLOAD_RECEIPTS';
export const BULK_UPLOAD_RECEIPTS_SUCCESS = 'BULK_UPLOAD_RECEIPTS_SUCCESS';
export const BULK_UPLOAD_RECEIPTS_FAILURE = 'BULK_UPLOAD_RECEIPTS_FAILURE';
export const CLEAR_RECEIPT_BULK_UPLOAD_STATE = 'CLEAR_RECEIPT_BULK_UPLOAD_STATE';

// GL Accounts (Non-Group, Excluding Expenses)
export const GET_GL_ACCOUNTS = 'GET_GL_ACCOUNTS';
export const GET_GL_ACCOUNTS_SUCCESS = 'GET_GL_ACCOUNTS_SUCCESS';
export const GET_GL_ACCOUNTS_FAILURE = 'GET_GL_ACCOUNTS_FAILURE';

export const BULK_GET_RECEIPT_DETAILS = 'BULK_GET_RECEIPT_DETAILS';
export const BULK_GET_RECEIPT_DETAILS_SUCCESS = 'BULK_GET_RECEIPT_DETAILS_SUCCESS';
export const BULK_GET_RECEIPT_DETAILS_FAILURE = 'BULK_GET_RECEIPT_DETAILS_FAILURE';

export const BULK_CANCEL_RECEIPTS = 'BULK_CANCEL_RECEIPTS';
export const BULK_CANCEL_RECEIPTS_SUCCESS = 'BULK_CANCEL_RECEIPTS_SUCCESS';
export const BULK_CANCEL_RECEIPTS_FAILURE = 'BULK_CANCEL_RECEIPTS_FAILURE';

export const BULK_BOUNCE_RECEIPTS = 'BULK_BOUNCE_RECEIPTS';
export const BULK_BOUNCE_RECEIPTS_SUCCESS = 'BULK_BOUNCE_RECEIPTS_SUCCESS';
export const BULK_BOUNCE_RECEIPTS_FAILURE = 'BULK_BOUNCE_RECEIPTS_FAILURE';

export const BULK_CLEAR_RECEIPTS = 'BULK_CLEAR_RECEIPTS';
export const BULK_CLEAR_RECEIPTS_SUCCESS = 'BULK_CLEAR_RECEIPTS_SUCCESS';
export const BULK_CLEAR_RECEIPTS_FAILURE = 'BULK_CLEAR_RECEIPTS_FAILURE';

export const GET_CHART_OF_ACCOUNTS_DROPDOWN = 'GET_CHART_OF_ACCOUNTS_DROPDOWN';
export const GET_CHART_OF_ACCOUNTS_DROPDOWN_SUCCESS = 'GET_CHART_OF_ACCOUNTS_DROPDOWN_SUCCESS';
export const GET_CHART_OF_ACCOUNTS_DROPDOWN_FAILURE = 'GET_CHART_OF_ACCOUNTS_DROPDOWN_FAILURE';

//------------SOCIETY BANK ACCOUNTS--------------//
export const GET_SOCIETY_BANKS = 'GET_SOCIETY_BANKS';
export const GET_SOCIETY_BANKS_SUCCESS = 'GET_SOCIETY_BANKS_SUCCESS';
export const GET_SOCIETY_BANKS_FAILURE = 'GET_SOCIETY_BANKS_FAILURE';

export const GET_SOCIETY_BANK_DETAILS = 'GET_SOCIETY_BANK_DETAILS';
export const GET_SOCIETY_BANK_DETAILS_SUCCESS = 'GET_SOCIETY_BANK_DETAILS_SUCCESS';
export const GET_SOCIETY_BANK_DETAILS_FAILURE = 'GET_SOCIETY_BANK_DETAILS_FAILURE';

export const CREATE_SOCIETY_BANK = 'CREATE_SOCIETY_BANK';
export const CREATE_SOCIETY_BANK_SUCCESS = 'CREATE_SOCIETY_BANK_SUCCESS';
export const CREATE_SOCIETY_BANK_FAILURE = 'CREATE_SOCIETY_BANK_FAILURE';

export const UPDATE_SOCIETY_BANK = 'UPDATE_SOCIETY_BANK';
export const UPDATE_SOCIETY_BANK_SUCCESS = 'UPDATE_SOCIETY_BANK_SUCCESS';
export const UPDATE_SOCIETY_BANK_FAILURE = 'UPDATE_SOCIETY_BANK_FAILURE';

export const DELETE_SOCIETY_BANK = 'DELETE_SOCIETY_BANK';
export const DELETE_SOCIETY_BANK_SUCCESS = 'DELETE_SOCIETY_BANK_SUCCESS';
export const DELETE_SOCIETY_BANK_FAILURE = 'DELETE_SOCIETY_BANK_FAILURE';

export const GET_BANK_JOURNAL_ENTRIES = 'GET_BANK_JOURNAL_ENTRIES';
export const GET_BANK_JOURNAL_ENTRIES_SUCCESS = 'GET_BANK_JOURNAL_ENTRIES_SUCCESS';
export const GET_BANK_JOURNAL_ENTRIES_FAILURE = 'GET_BANK_JOURNAL_ENTRIES_FAILURE';

export const GET_SOCIETY_BANKS_DROPDOWN = 'GET_SOCIETY_BANKS_DROPDOWN';
export const GET_SOCIETY_BANKS_DROPDOWN_SUCCESS = 'GET_SOCIETY_BANKS_DROPDOWN_SUCCESS';
export const GET_SOCIETY_BANKS_DROPDOWN_FAILURE = 'GET_SOCIETY_BANKS_DROPDOWN_FAILURE';

// Vendor Dropdown
export const SOCIETY_GET_VENDORS_DROPDOWN = 'SOCIETY_GET_VENDORS_DROPDOWN';
export const SOCIETY_GET_VENDORS_DROPDOWN_SUCCESS = 'SOCIETY_GET_VENDORS_DROPDOWN_SUCCESS';
export const SOCIETY_GET_VENDORS_DROPDOWN_FAILURE = 'SOCIETY_GET_VENDORS_DROPDOWN_FAILURE';

// Fixed Assets
export const CREATE_FIXED_ASSET = 'CREATE_FIXED_ASSET';
export const CREATE_FIXED_ASSET_SUCCESS = 'CREATE_FIXED_ASSET_SUCCESS';
export const CREATE_FIXED_ASSET_FAILURE = 'CREATE_FIXED_ASSET_FAILURE';

export const GET_FIXED_ASSETS = 'GET_FIXED_ASSETS';
export const GET_FIXED_ASSETS_SUCCESS = 'GET_FIXED_ASSETS_SUCCESS';
export const GET_FIXED_ASSETS_FAILURE = 'GET_FIXED_ASSETS_FAILURE';

export const GET_DEPRECIATION_METHODS = 'GET_DEPRECIATION_METHODS';
export const GET_DEPRECIATION_METHODS_SUCCESS = 'GET_DEPRECIATION_METHODS_SUCCESS';
export const GET_DEPRECIATION_METHODS_FAILURE = 'GET_DEPRECIATION_METHODS_FAILURE';

export const GET_FIXED_ASSET_CATEGORIES = 'GET_FIXED_ASSET_CATEGORIES';
export const GET_FIXED_ASSET_CATEGORIES_SUCCESS = 'GET_FIXED_ASSET_CATEGORIES_SUCCESS';
export const GET_FIXED_ASSET_CATEGORIES_FAILURE = 'GET_FIXED_ASSET_CATEGORIES_FAILURE';

export const GET_FIXED_ASSET_DETAILS = 'GET_FIXED_ASSET_DETAILS';
export const GET_FIXED_ASSET_DETAILS_SUCCESS = 'GET_FIXED_ASSET_DETAILS_SUCCESS';
export const GET_FIXED_ASSET_DETAILS_FAILURE = 'GET_FIXED_ASSET_DETAILS_FAILURE';

export const UPDATE_FIXED_ASSET = 'UPDATE_FIXED_ASSET';
export const UPDATE_FIXED_ASSET_SUCCESS = 'UPDATE_FIXED_ASSET_SUCCESS';
export const UPDATE_FIXED_ASSET_FAILURE = 'UPDATE_FIXED_ASSET_FAILURE';

export const DELETE_FIXED_ASSET = 'DELETE_FIXED_ASSET';
export const DELETE_FIXED_ASSET_SUCCESS = 'DELETE_FIXED_ASSET_SUCCESS';
export const DELETE_FIXED_ASSET_FAILURE = 'DELETE_FIXED_ASSET_FAILURE';

export const CLEAR_FIXED_ASSET_STATE = 'CLEAR_FIXED_ASSET_STATE';

// Invoice Report Actions
export const GET_INVOICE_REPORT = 'GET_INVOICE_REPORT';
export const GET_INVOICE_REPORT_SUCCESS = 'GET_INVOICE_REPORT_SUCCESS';
export const GET_INVOICE_REPORT_FAILURE = 'GET_INVOICE_REPORT_FAILURE';

// Invoice Aging Report Actions
export const GET_INVOICE_AGING_REPORT = 'GET_INVOICE_AGING_REPORT';
export const GET_INVOICE_AGING_REPORT_SUCCESS = 'GET_INVOICE_AGING_REPORT_SUCCESS';
export const GET_INVOICE_AGING_REPORT_FAILURE = 'GET_INVOICE_AGING_REPORT_FAILURE';

// Interest Calculation Report Actions
export const GET_INTEREST_REPORT = 'GET_INTEREST_REPORT';
export const GET_INTEREST_REPORT_SUCCESS = 'GET_INTEREST_REPORT_SUCCESS';
export const GET_INTEREST_REPORT_FAILURE = 'GET_INTEREST_REPORT_FAILURE';

// Receipt Report Actions
export const GET_RECEIPT_REPORT = 'GET_RECEIPT_REPORT';
export const GET_RECEIPT_REPORT_SUCCESS = 'GET_RECEIPT_REPORT_SUCCESS';
export const GET_RECEIPT_REPORT_FAILURE = 'GET_RECEIPT_REPORT_FAILURE';

// Credit/Debit Note Report Actions
export const GET_CD_NOTE_REPORT = 'GET_CD_NOTE_REPORT';
export const GET_CD_NOTE_REPORT_SUCCESS = 'GET_CD_NOTE_REPORT_SUCCESS';
export const GET_CD_NOTE_REPORT_FAILURE = 'GET_CD_NOTE_REPORT_FAILURE';

// GST Report Actions
export const GET_GST_REPORT = 'GET_GST_REPORT';
export const GET_GST_REPORT_SUCCESS = 'GET_GST_REPORT_SUCCESS';
export const GET_GST_REPORT_FAILURE = 'GET_GST_REPORT_FAILURE';

// Reconciliation Report Actions
export const GET_RECONCILIATION_REPORT = 'GET_RECONCILIATION_REPORT';
export const GET_RECONCILIATION_REPORT_SUCCESS = 'GET_RECONCILIATION_REPORT_SUCCESS';
export const GET_RECONCILIATION_REPORT_FAILURE = 'GET_RECONCILIATION_REPORT_FAILURE';

// Cash & Bank Module
export const GET_CASH_BANK_LIST = 'GET_CASH_BANK_LIST';
export const GET_CASH_BANK_LIST_SUCCESS = 'GET_CASH_BANK_LIST_SUCCESS';
export const GET_CASH_BANK_LIST_FAILURE = 'GET_CASH_BANK_LIST_FAILURE';

export const GET_CASH_BANK_ENTRIES = 'GET_CASH_BANK_ENTRIES';
export const GET_CASH_BANK_ENTRIES_SUCCESS = 'GET_CASH_BANK_ENTRIES_SUCCESS';
export const GET_CASH_BANK_ENTRIES_FAILURE = 'GET_CASH_BANK_ENTRIES_FAILURE';

export const GET_CASH_BANK_SUMMARY = 'GET_CASH_BANK_SUMMARY';
export const GET_CASH_BANK_SUMMARY_SUCCESS = 'GET_CASH_BANK_SUMMARY_SUCCESS';
export const GET_CASH_BANK_SUMMARY_FAILURE = 'GET_CASH_BANK_SUMMARY_FAILURE';

export const CLEAR_CASH_BANK_STATE = 'CLEAR_CASH_BANK_STATE';

// Investments (Fixed Deposits)
export const GET_INVESTMENTS = 'GET_INVESTMENTS';
export const GET_INVESTMENTS_SUCCESS = 'GET_INVESTMENTS_SUCCESS';
export const GET_INVESTMENTS_FAILURE = 'GET_INVESTMENTS_FAILURE';

export const GET_INVESTMENT_DETAILS = 'GET_INVESTMENT_DETAILS';
export const GET_INVESTMENT_DETAILS_SUCCESS = 'GET_INVESTMENT_DETAILS_SUCCESS';
export const GET_INVESTMENT_DETAILS_FAILURE = 'GET_INVESTMENT_DETAILS_FAILURE';

export const CREATE_INVESTMENT = 'CREATE_INVESTMENT';
export const CREATE_INVESTMENT_SUCCESS = 'CREATE_INVESTMENT_SUCCESS';
export const CREATE_INVESTMENT_FAILURE = 'CREATE_INVESTMENT_FAILURE';

export const UPDATE_INVESTMENT = 'UPDATE_INVESTMENT';
export const UPDATE_INVESTMENT_SUCCESS = 'UPDATE_INVESTMENT_SUCCESS';
export const UPDATE_INVESTMENT_FAILURE = 'UPDATE_INVESTMENT_FAILURE';

export const DELETE_INVESTMENT = 'DELETE_INVESTMENT';
export const DELETE_INVESTMENT_SUCCESS = 'DELETE_INVESTMENT_SUCCESS';
export const DELETE_INVESTMENT_FAILURE = 'DELETE_INVESTMENT_FAILURE';

export const CALCULATE_INVESTMENT_PREVIEW = 'CALCULATE_INVESTMENT_PREVIEW';
export const CALCULATE_INVESTMENT_PREVIEW_SUCCESS = 'CALCULATE_INVESTMENT_PREVIEW_SUCCESS';
export const CALCULATE_INVESTMENT_PREVIEW_FAILURE = 'CALCULATE_INVESTMENT_PREVIEW_FAILURE';
export const CLEAR_INVESTMENT_PREVIEW = 'CLEAR_INVESTMENT_PREVIEW';

export const MATURE_INVESTMENT = 'MATURE_INVESTMENT';
export const MATURE_INVESTMENT_SUCCESS = 'MATURE_INVESTMENT_SUCCESS';
export const MATURE_INVESTMENT_FAILURE = 'MATURE_INVESTMENT_FAILURE';

export const PRE_MATURE_INVESTMENT = 'PRE_MATURE_INVESTMENT';
export const PRE_MATURE_INVESTMENT_SUCCESS = 'PRE_MATURE_INVESTMENT_SUCCESS';
export const PRE_MATURE_INVESTMENT_FAILURE = 'PRE_MATURE_INVESTMENT_FAILURE';

export const RENEW_INVESTMENT = 'RENEW_INVESTMENT';
export const RENEW_INVESTMENT_SUCCESS = 'RENEW_INVESTMENT_SUCCESS';
export const RENEW_INVESTMENT_FAILURE = 'RENEW_INVESTMENT_FAILURE';

// Bank Reconciliation Statement (BRS)
export const GET_BRS_LIST = 'GET_BRS_LIST';
export const GET_BRS_LIST_SUCCESS = 'GET_BRS_LIST_SUCCESS';
export const GET_BRS_LIST_FAILURE = 'GET_BRS_LIST_FAILURE';

export const GET_BRS_DETAILS = 'GET_BRS_DETAILS';
export const GET_BRS_DETAILS_SUCCESS = 'GET_BRS_DETAILS_SUCCESS';
export const GET_BRS_DETAILS_FAILURE = 'GET_BRS_DETAILS_FAILURE';

export const CREATE_BRS = 'CREATE_BRS';
export const CREATE_BRS_SUCCESS = 'CREATE_BRS_SUCCESS';
export const CREATE_BRS_FAILURE = 'CREATE_BRS_FAILURE';

export const UPDATE_BRS = 'UPDATE_BRS';
export const UPDATE_BRS_SUCCESS = 'UPDATE_BRS_SUCCESS';
export const UPDATE_BRS_FAILURE = 'UPDATE_BRS_FAILURE';

export const FINALIZE_BRS = 'FINALIZE_BRS';
export const FINALIZE_BRS_SUCCESS = 'FINALIZE_BRS_SUCCESS';
export const FINALIZE_BRS_FAILURE = 'FINALIZE_BRS_FAILURE';

export const DELETE_BRS = 'DELETE_BRS';
export const DELETE_BRS_SUCCESS = 'DELETE_BRS_SUCCESS';
export const DELETE_BRS_FAILURE = 'DELETE_BRS_FAILURE';

export const CLEAR_BRS_ENTRIES = 'CLEAR_BRS_ENTRIES';
export const CLEAR_BRS_ENTRIES_SUCCESS = 'CLEAR_BRS_ENTRIES_SUCCESS';
export const CLEAR_BRS_ENTRIES_FAILURE = 'CLEAR_BRS_ENTRIES_FAILURE';

export const IMPORT_BRS_STATEMENT = 'IMPORT_BRS_STATEMENT';
export const IMPORT_BRS_STATEMENT_SUCCESS = 'IMPORT_BRS_STATEMENT_SUCCESS';
export const IMPORT_BRS_STATEMENT_FAILURE = 'IMPORT_BRS_STATEMENT_FAILURE';

export const AUTO_MATCH_BRS = 'AUTO_MATCH_BRS';
export const AUTO_MATCH_BRS_SUCCESS = 'AUTO_MATCH_BRS_SUCCESS';
export const AUTO_MATCH_BRS_FAILURE = 'AUTO_MATCH_BRS_FAILURE';

export const MANUAL_MATCH_BRS = 'MANUAL_MATCH_BRS';
export const MANUAL_MATCH_BRS_SUCCESS = 'MANUAL_MATCH_BRS_SUCCESS';
export const MANUAL_MATCH_BRS_FAILURE = 'MANUAL_MATCH_BRS_FAILURE';

export const UNMATCH_BRS = 'UNMATCH_BRS';
export const UNMATCH_BRS_SUCCESS = 'UNMATCH_BRS_SUCCESS';
export const UNMATCH_BRS_FAILURE = 'UNMATCH_BRS_FAILURE';

export const CLEAR_BRS_STATE = 'CLEAR_BRS_STATE';

// Account Reports
export const GET_INCOME_EXPENDITURE_REPORT = 'GET_INCOME_EXPENDITURE_REPORT';
export const GET_INCOME_EXPENDITURE_REPORT_SUCCESS = 'GET_INCOME_EXPENDITURE_REPORT_SUCCESS';
export const GET_INCOME_EXPENDITURE_REPORT_FAILURE = 'GET_INCOME_EXPENDITURE_REPORT_FAILURE';

export const GET_BALANCE_SHEET_REPORT = 'GET_BALANCE_SHEET_REPORT';
export const GET_BALANCE_SHEET_REPORT_SUCCESS = 'GET_BALANCE_SHEET_REPORT_SUCCESS';
export const GET_BALANCE_SHEET_REPORT_FAILURE = 'GET_BALANCE_SHEET_REPORT_FAILURE';

export const GET_TRIAL_BALANCE_REPORT = 'GET_TRIAL_BALANCE_REPORT';
export const GET_TRIAL_BALANCE_REPORT_SUCCESS = 'GET_TRIAL_BALANCE_REPORT_SUCCESS';
export const GET_TRIAL_BALANCE_REPORT_FAILURE = 'GET_TRIAL_BALANCE_REPORT_FAILURE';

export const GET_GROUP_LEDGER_REPORT = 'GET_GROUP_LEDGER_REPORT';
export const GET_GROUP_LEDGER_REPORT_SUCCESS = 'GET_GROUP_LEDGER_REPORT_SUCCESS';
export const GET_GROUP_LEDGER_REPORT_FAILURE = 'GET_GROUP_LEDGER_REPORT_FAILURE';

export const GET_ACCOUNT_LEDGER_REPORT = 'GET_ACCOUNT_LEDGER_REPORT';
export const GET_ACCOUNT_LEDGER_REPORT_SUCCESS = 'GET_ACCOUNT_LEDGER_REPORT_SUCCESS';
export const GET_ACCOUNT_LEDGER_REPORT_FAILURE = 'GET_ACCOUNT_LEDGER_REPORT_FAILURE';

export const GET_MONTHLY_INCOME_REPORT = 'GET_MONTHLY_INCOME_REPORT';
export const GET_MONTHLY_INCOME_REPORT_SUCCESS = 'GET_MONTHLY_INCOME_REPORT_SUCCESS';
export const GET_MONTHLY_INCOME_REPORT_FAILURE = 'GET_MONTHLY_INCOME_REPORT_FAILURE';

export const GET_MONTHLY_EXPENDITURE_REPORT = 'GET_MONTHLY_EXPENDITURE_REPORT';
export const GET_MONTHLY_EXPENDITURE_REPORT_SUCCESS = 'GET_MONTHLY_EXPENDITURE_REPORT_SUCCESS';
export const GET_MONTHLY_EXPENDITURE_REPORT_FAILURE = 'GET_MONTHLY_EXPENDITURE_REPORT_FAILURE';

// ============ EMPLOYEES ============
export const SOCIETY_GET_EMPLOYEES_LIST = 'SOCIETY_GET_EMPLOYEES_LIST';
export const SOCIETY_GET_EMPLOYEES_LIST_SUCCESS = 'SOCIETY_GET_EMPLOYEES_LIST_SUCCESS';
export const SOCIETY_GET_EMPLOYEES_LIST_FAILURE = 'SOCIETY_GET_EMPLOYEES_LIST_FAILURE';

export const SOCIETY_GET_EMPLOYEE_DETAILS = 'SOCIETY_GET_EMPLOYEE_DETAILS';
export const SOCIETY_GET_EMPLOYEE_DETAILS_SUCCESS = 'SOCIETY_GET_EMPLOYEE_DETAILS_SUCCESS';
export const SOCIETY_GET_EMPLOYEE_DETAILS_FAILURE = 'SOCIETY_GET_EMPLOYEE_DETAILS_FAILURE';

export const SOCIETY_CREATE_EMPLOYEE = 'SOCIETY_CREATE_EMPLOYEE';
export const SOCIETY_CREATE_EMPLOYEE_SUCCESS = 'SOCIETY_CREATE_EMPLOYEE_SUCCESS';
export const SOCIETY_CREATE_EMPLOYEE_FAILURE = 'SOCIETY_CREATE_EMPLOYEE_FAILURE';

export const SOCIETY_UPDATE_EMPLOYEE = 'SOCIETY_UPDATE_EMPLOYEE';
export const SOCIETY_UPDATE_EMPLOYEE_SUCCESS = 'SOCIETY_UPDATE_EMPLOYEE_SUCCESS';
export const SOCIETY_UPDATE_EMPLOYEE_FAILURE = 'SOCIETY_UPDATE_EMPLOYEE_FAILURE';

export const SOCIETY_DELETE_EMPLOYEE = 'SOCIETY_DELETE_EMPLOYEE';
export const SOCIETY_DELETE_EMPLOYEE_SUCCESS = 'SOCIETY_DELETE_EMPLOYEE_SUCCESS';
export const SOCIETY_DELETE_EMPLOYEE_FAILURE = 'SOCIETY_DELETE_EMPLOYEE_FAILURE';

export const SOCIETY_GET_EMPLOYEE_TYPES = 'SOCIETY_GET_EMPLOYEE_TYPES';
export const SOCIETY_GET_EMPLOYEE_TYPES_SUCCESS = 'SOCIETY_GET_EMPLOYEE_TYPES_SUCCESS';
export const SOCIETY_GET_EMPLOYEE_TYPES_FAILURE = 'SOCIETY_GET_EMPLOYEE_TYPES_FAILURE';

export const SOCIETY_GET_COUNTRIES_DROPDOWN = 'SOCIETY_GET_COUNTRIES_DROPDOWN';
export const SOCIETY_GET_COUNTRIES_DROPDOWN_SUCCESS = 'SOCIETY_GET_COUNTRIES_DROPDOWN_SUCCESS';
export const SOCIETY_GET_COUNTRIES_DROPDOWN_FAILURE = 'SOCIETY_GET_COUNTRIES_DROPDOWN_FAILURE';

export const SOCIETY_GET_EMPLOYEE_AUDIT_LOG = 'SOCIETY_GET_EMPLOYEE_AUDIT_LOG';
export const SOCIETY_GET_EMPLOYEE_AUDIT_LOG_SUCCESS = 'SOCIETY_GET_EMPLOYEE_AUDIT_LOG_SUCCESS';
export const SOCIETY_GET_EMPLOYEE_AUDIT_LOG_FAILURE = 'SOCIETY_GET_EMPLOYEE_AUDIT_LOG_FAILURE';

export const SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL = 'SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL';
export const SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_SUCCESS = 'SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_SUCCESS';
export const SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE = 'SOCIETY_SEARCH_EMPLOYEE_BY_EMAIL_FAILURE';
export const SOCIETY_CLEAR_EMPLOYEE_SEARCH = 'SOCIETY_CLEAR_EMPLOYEE_SEARCH';

export const SOCIETY_LINK_EXISTING_EMPLOYEE = 'SOCIETY_LINK_EXISTING_EMPLOYEE';
export const SOCIETY_LINK_EXISTING_EMPLOYEE_SUCCESS = 'SOCIETY_LINK_EXISTING_EMPLOYEE_SUCCESS';
export const SOCIETY_LINK_EXISTING_EMPLOYEE_FAILURE = 'SOCIETY_LINK_EXISTING_EMPLOYEE_FAILURE';

export const SOCIETY_GET_USERNAMES_DROPDOWN = 'SOCIETY_GET_USERNAMES_DROPDOWN';
export const SOCIETY_GET_USERNAMES_DROPDOWN_SUCCESS = 'SOCIETY_GET_USERNAMES_DROPDOWN_SUCCESS';
export const SOCIETY_GET_USERNAMES_DROPDOWN_FAILURE = 'SOCIETY_GET_USERNAMES_DROPDOWN_FAILURE';

export const SOCIETY_GET_EMPLOYEES_DROPDOWN = 'SOCIETY_GET_EMPLOYEES_DROPDOWN';
export const SOCIETY_GET_EMPLOYEES_DROPDOWN_SUCCESS = 'SOCIETY_GET_EMPLOYEES_DROPDOWN_SUCCESS';
export const SOCIETY_GET_EMPLOYEES_DROPDOWN_FAILURE = 'SOCIETY_GET_EMPLOYEES_DROPDOWN_FAILURE';


// Attendance report (geofenced login/logout history)
export const SOCIETY_GET_ATTENDANCE_REPORT = 'SOCIETY_GET_ATTENDANCE_REPORT';
export const SOCIETY_GET_ATTENDANCE_REPORT_SUCCESS = 'SOCIETY_GET_ATTENDANCE_REPORT_SUCCESS';
export const SOCIETY_GET_ATTENDANCE_REPORT_FAILURE = 'SOCIETY_GET_ATTENDANCE_REPORT_FAILURE';

// Employee Attendance — shift punch in/out (self-service, /api/attendance)
export const SOCIETY_GET_MY_ATTENDANCE_STATUS = 'SOCIETY_GET_MY_ATTENDANCE_STATUS';
export const SOCIETY_GET_MY_ATTENDANCE_STATUS_SUCCESS = 'SOCIETY_GET_MY_ATTENDANCE_STATUS_SUCCESS';
export const SOCIETY_GET_MY_ATTENDANCE_STATUS_FAILURE = 'SOCIETY_GET_MY_ATTENDANCE_STATUS_FAILURE';

export const SOCIETY_PUNCH_ATTENDANCE = 'SOCIETY_PUNCH_ATTENDANCE';
export const SOCIETY_PUNCH_ATTENDANCE_SUCCESS = 'SOCIETY_PUNCH_ATTENDANCE_SUCCESS';
export const SOCIETY_PUNCH_ATTENDANCE_FAILURE = 'SOCIETY_PUNCH_ATTENDANCE_FAILURE';

export const SOCIETY_GET_MY_ATTENDANCE_PUNCHES = 'SOCIETY_GET_MY_ATTENDANCE_PUNCHES';
export const SOCIETY_GET_MY_ATTENDANCE_PUNCHES_SUCCESS = 'SOCIETY_GET_MY_ATTENDANCE_PUNCHES_SUCCESS';
export const SOCIETY_GET_MY_ATTENDANCE_PUNCHES_FAILURE = 'SOCIETY_GET_MY_ATTENDANCE_PUNCHES_FAILURE';

export const SOCIETY_GET_MY_ATTENDANCE_SUMMARY = 'SOCIETY_GET_MY_ATTENDANCE_SUMMARY';
export const SOCIETY_GET_MY_ATTENDANCE_SUMMARY_SUCCESS = 'SOCIETY_GET_MY_ATTENDANCE_SUMMARY_SUCCESS';
export const SOCIETY_GET_MY_ATTENDANCE_SUMMARY_FAILURE = 'SOCIETY_GET_MY_ATTENDANCE_SUMMARY_FAILURE';

export const SOCIETY_GET_ATTENDANCE_ENUMS = 'SOCIETY_GET_ATTENDANCE_ENUMS';
export const SOCIETY_GET_ATTENDANCE_ENUMS_SUCCESS = 'SOCIETY_GET_ATTENDANCE_ENUMS_SUCCESS';
export const SOCIETY_GET_ATTENDANCE_ENUMS_FAILURE = 'SOCIETY_GET_ATTENDANCE_ENUMS_FAILURE';

export const SOCIETY_UPDATE_ATTENDANCE_PUNCH = 'SOCIETY_UPDATE_ATTENDANCE_PUNCH';
export const SOCIETY_UPDATE_ATTENDANCE_PUNCH_SUCCESS = 'SOCIETY_UPDATE_ATTENDANCE_PUNCH_SUCCESS';
export const SOCIETY_UPDATE_ATTENDANCE_PUNCH_FAILURE = 'SOCIETY_UPDATE_ATTENDANCE_PUNCH_FAILURE';

export const SOCIETY_GET_ADMIN_ATTENDANCE_DAILY = 'SOCIETY_GET_ADMIN_ATTENDANCE_DAILY';
export const SOCIETY_GET_ADMIN_ATTENDANCE_DAILY_SUCCESS = 'SOCIETY_GET_ADMIN_ATTENDANCE_DAILY_SUCCESS';
export const SOCIETY_GET_ADMIN_ATTENDANCE_DAILY_FAILURE = 'SOCIETY_GET_ADMIN_ATTENDANCE_DAILY_FAILURE';

export const SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY = 'SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY';
export const SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY_SUCCESS = 'SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY_SUCCESS';
export const SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY_FAILURE = 'SOCIETY_GET_ADMIN_ATTENDANCE_SUMMARY_FAILURE';

export const SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES = 'SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES';
export const SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES_SUCCESS = 'SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES_SUCCESS';
export const SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES_FAILURE = 'SOCIETY_GET_ADMIN_ATTENDANCE_PUNCHES_FAILURE';

export const SOCIETY_CREATE_MANUAL_PUNCH = 'SOCIETY_CREATE_MANUAL_PUNCH';
export const SOCIETY_CREATE_MANUAL_PUNCH_SUCCESS = 'SOCIETY_CREATE_MANUAL_PUNCH_SUCCESS';
export const SOCIETY_CREATE_MANUAL_PUNCH_FAILURE = 'SOCIETY_CREATE_MANUAL_PUNCH_FAILURE';

export const SOCIETY_APPROVE_ATTENDANCE_PUNCH = 'SOCIETY_APPROVE_ATTENDANCE_PUNCH';
export const SOCIETY_APPROVE_ATTENDANCE_PUNCH_SUCCESS = 'SOCIETY_APPROVE_ATTENDANCE_PUNCH_SUCCESS';
export const SOCIETY_APPROVE_ATTENDANCE_PUNCH_FAILURE = 'SOCIETY_APPROVE_ATTENDANCE_PUNCH_FAILURE';

export const SOCIETY_REJECT_ATTENDANCE_PUNCH = 'SOCIETY_REJECT_ATTENDANCE_PUNCH';
export const SOCIETY_REJECT_ATTENDANCE_PUNCH_SUCCESS = 'SOCIETY_REJECT_ATTENDANCE_PUNCH_SUCCESS';
export const SOCIETY_REJECT_ATTENDANCE_PUNCH_FAILURE = 'SOCIETY_REJECT_ATTENDANCE_PUNCH_FAILURE';

// ============ COMPLAINTS ============
export const SOCIETY_GET_COMPLAINTS_LIST = 'SOCIETY_GET_COMPLAINTS_LIST';
export const SOCIETY_GET_COMPLAINTS_LIST_SUCCESS = 'SOCIETY_GET_COMPLAINTS_LIST_SUCCESS';
export const SOCIETY_GET_COMPLAINTS_LIST_FAILURE = 'SOCIETY_GET_COMPLAINTS_LIST_FAILURE';

export const SOCIETY_GET_COMPLAINT_DETAILS = 'SOCIETY_GET_COMPLAINT_DETAILS';
export const SOCIETY_GET_COMPLAINT_DETAILS_SUCCESS = 'SOCIETY_GET_COMPLAINT_DETAILS_SUCCESS';
export const SOCIETY_GET_COMPLAINT_DETAILS_FAILURE = 'SOCIETY_GET_COMPLAINT_DETAILS_FAILURE';

export const SOCIETY_CREATE_COMPLAINT = 'SOCIETY_CREATE_COMPLAINT';
export const SOCIETY_CREATE_COMPLAINT_SUCCESS = 'SOCIETY_CREATE_COMPLAINT_SUCCESS';
export const SOCIETY_CREATE_COMPLAINT_FAILURE = 'SOCIETY_CREATE_COMPLAINT_FAILURE';

export const SOCIETY_UPDATE_COMPLAINT = 'SOCIETY_UPDATE_COMPLAINT';
export const SOCIETY_UPDATE_COMPLAINT_SUCCESS = 'SOCIETY_UPDATE_COMPLAINT_SUCCESS';
export const SOCIETY_UPDATE_COMPLAINT_FAILURE = 'SOCIETY_UPDATE_COMPLAINT_FAILURE';

export const SOCIETY_DELETE_COMPLAINT = 'SOCIETY_DELETE_COMPLAINT';
export const SOCIETY_DELETE_COMPLAINT_SUCCESS = 'SOCIETY_DELETE_COMPLAINT_SUCCESS';
export const SOCIETY_DELETE_COMPLAINT_FAILURE = 'SOCIETY_DELETE_COMPLAINT_FAILURE';

export const SOCIETY_CHANGE_COMPLAINT_STATUS = 'SOCIETY_CHANGE_COMPLAINT_STATUS';
export const SOCIETY_CHANGE_COMPLAINT_STATUS_SUCCESS = 'SOCIETY_CHANGE_COMPLAINT_STATUS_SUCCESS';
export const SOCIETY_CHANGE_COMPLAINT_STATUS_FAILURE = 'SOCIETY_CHANGE_COMPLAINT_STATUS_FAILURE';

export const SOCIETY_ASSIGN_COMPLAINT = 'SOCIETY_ASSIGN_COMPLAINT';
export const SOCIETY_ASSIGN_COMPLAINT_SUCCESS = 'SOCIETY_ASSIGN_COMPLAINT_SUCCESS';
export const SOCIETY_ASSIGN_COMPLAINT_FAILURE = 'SOCIETY_ASSIGN_COMPLAINT_FAILURE';

export const SOCIETY_ADD_COMPLAINT_COMMENT = 'SOCIETY_ADD_COMPLAINT_COMMENT';
export const SOCIETY_ADD_COMPLAINT_COMMENT_SUCCESS = 'SOCIETY_ADD_COMPLAINT_COMMENT_SUCCESS';
export const SOCIETY_ADD_COMPLAINT_COMMENT_FAILURE = 'SOCIETY_ADD_COMPLAINT_COMMENT_FAILURE';

export const SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS = 'SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS';
export const SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_SUCCESS = 'SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_SUCCESS';
export const SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE = 'SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE';

export const SOCIETY_DELETE_COMPLAINT_ATTACHMENT = 'SOCIETY_DELETE_COMPLAINT_ATTACHMENT';
export const SOCIETY_DELETE_COMPLAINT_ATTACHMENT_SUCCESS = 'SOCIETY_DELETE_COMPLAINT_ATTACHMENT_SUCCESS';
export const SOCIETY_DELETE_COMPLAINT_ATTACHMENT_FAILURE = 'SOCIETY_DELETE_COMPLAINT_ATTACHMENT_FAILURE';

export const SOCIETY_GET_COMPLAINT_ENUMS = 'SOCIETY_GET_COMPLAINT_ENUMS';
export const SOCIETY_GET_COMPLAINT_ENUMS_SUCCESS = 'SOCIETY_GET_COMPLAINT_ENUMS_SUCCESS';
export const SOCIETY_GET_COMPLAINT_ENUMS_FAILURE = 'SOCIETY_GET_COMPLAINT_ENUMS_FAILURE';

export const SOCIETY_GET_COMPLAINT_STATS = 'SOCIETY_GET_COMPLAINT_STATS';
export const SOCIETY_GET_COMPLAINT_STATS_SUCCESS = 'SOCIETY_GET_COMPLAINT_STATS_SUCCESS';
export const SOCIETY_GET_COMPLAINT_STATS_FAILURE = 'SOCIETY_GET_COMPLAINT_STATS_FAILURE';

// Complaint Categories
export const SOCIETY_GET_COMPLAINT_CATEGORIES = 'SOCIETY_GET_COMPLAINT_CATEGORIES';
export const SOCIETY_GET_COMPLAINT_CATEGORIES_SUCCESS = 'SOCIETY_GET_COMPLAINT_CATEGORIES_SUCCESS';
export const SOCIETY_GET_COMPLAINT_CATEGORIES_FAILURE = 'SOCIETY_GET_COMPLAINT_CATEGORIES_FAILURE';

export const SOCIETY_CREATE_COMPLAINT_CATEGORY = 'SOCIETY_CREATE_COMPLAINT_CATEGORY';
export const SOCIETY_CREATE_COMPLAINT_CATEGORY_SUCCESS = 'SOCIETY_CREATE_COMPLAINT_CATEGORY_SUCCESS';
export const SOCIETY_CREATE_COMPLAINT_CATEGORY_FAILURE = 'SOCIETY_CREATE_COMPLAINT_CATEGORY_FAILURE';

export const SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES = 'SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES';
export const SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES_SUCCESS = 'SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES_SUCCESS';
export const SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES_FAILURE = 'SOCIETY_BULK_CREATE_COMPLAINT_CATEGORIES_FAILURE';

export const SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI = 'SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI';
export const SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_SUCCESS = 'SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_SUCCESS';
export const SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_FAILURE = 'SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_FAILURE';

export const SOCIETY_UPDATE_COMPLAINT_CATEGORY = 'SOCIETY_UPDATE_COMPLAINT_CATEGORY';
export const SOCIETY_UPDATE_COMPLAINT_CATEGORY_SUCCESS = 'SOCIETY_UPDATE_COMPLAINT_CATEGORY_SUCCESS';
export const SOCIETY_UPDATE_COMPLAINT_CATEGORY_FAILURE = 'SOCIETY_UPDATE_COMPLAINT_CATEGORY_FAILURE';

export const SOCIETY_DELETE_COMPLAINT_CATEGORY = 'SOCIETY_DELETE_COMPLAINT_CATEGORY';
export const SOCIETY_DELETE_COMPLAINT_CATEGORY_SUCCESS = 'SOCIETY_DELETE_COMPLAINT_CATEGORY_SUCCESS';
export const SOCIETY_DELETE_COMPLAINT_CATEGORY_FAILURE = 'SOCIETY_DELETE_COMPLAINT_CATEGORY_FAILURE';

// 3.6 — Employee complaint history
export const SOCIETY_GET_EMPLOYEE_COMPLAINTS = 'SOCIETY_GET_EMPLOYEE_COMPLAINTS';
export const SOCIETY_GET_EMPLOYEE_COMPLAINTS_SUCCESS = 'SOCIETY_GET_EMPLOYEE_COMPLAINTS_SUCCESS';
export const SOCIETY_GET_EMPLOYEE_COMPLAINTS_FAILURE = 'SOCIETY_GET_EMPLOYEE_COMPLAINTS_FAILURE';

// Rating (customer feedback)
export const SOCIETY_RATE_COMPLAINT = 'SOCIETY_RATE_COMPLAINT';
export const SOCIETY_RATE_COMPLAINT_SUCCESS = 'SOCIETY_RATE_COMPLAINT_SUCCESS';
export const SOCIETY_RATE_COMPLAINT_FAILURE = 'SOCIETY_RATE_COMPLAINT_FAILURE';

// Complaint audit log
export const SOCIETY_GET_COMPLAINT_AUDIT_LOG = 'SOCIETY_GET_COMPLAINT_AUDIT_LOG';
export const SOCIETY_GET_COMPLAINT_AUDIT_LOG_SUCCESS = 'SOCIETY_GET_COMPLAINT_AUDIT_LOG_SUCCESS';
export const SOCIETY_GET_COMPLAINT_AUDIT_LOG_FAILURE = 'SOCIETY_GET_COMPLAINT_AUDIT_LOG_FAILURE';

export const CLEAR_ACCOUNT_REPORTS_STATE = 'CLEAR_ACCOUNT_REPORTS_STATE';

export const CLEAR_INVESTMENT_STATE = 'CLEAR_INVESTMENT_STATE';

// ------ ROLES & PERMISSIONS ------------

export const GET_SOCIETY_ROLES = 'GET_SOCIETY_ROLES';
export const GET_SOCIETY_ROLES_SUCCESS = 'GET_SOCIETY_ROLES_SUCCESS';
export const GET_SOCIETY_ROLES_FAILURE = 'GET_SOCIETY_ROLES_FAILURE';

export const GET_SOCIETY_ROLE_DETAILS = 'GET_SOCIETY_ROLE_DETAILS';
export const GET_SOCIETY_ROLE_DETAILS_SUCCESS = 'GET_SOCIETY_ROLE_DETAILS_SUCCESS';
export const GET_SOCIETY_ROLE_DETAILS_FAILURE = 'GET_SOCIETY_ROLE_DETAILS_FAILURE';

export const CREATE_SOCIETY_ROLE = 'CREATE_SOCIETY_ROLE';
export const CREATE_SOCIETY_ROLE_SUCCESS = 'CREATE_SOCIETY_ROLE_SUCCESS';
export const CREATE_SOCIETY_ROLE_FAILURE = 'CREATE_SOCIETY_ROLE_FAILURE';

export const UPDATE_SOCIETY_ROLE = 'UPDATE_SOCIETY_ROLE';
export const UPDATE_SOCIETY_ROLE_SUCCESS = 'UPDATE_SOCIETY_ROLE_SUCCESS';
export const UPDATE_SOCIETY_ROLE_FAILURE = 'UPDATE_SOCIETY_ROLE_FAILURE';

export const DELETE_SOCIETY_ROLE = 'DELETE_SOCIETY_ROLE';
export const DELETE_SOCIETY_ROLE_SUCCESS = 'DELETE_SOCIETY_ROLE_SUCCESS';
export const DELETE_SOCIETY_ROLE_FAILURE = 'DELETE_SOCIETY_ROLE_FAILURE';

export const ASSIGN_ROLE_PERMISSIONS = 'ASSIGN_ROLE_PERMISSIONS';
export const ASSIGN_ROLE_PERMISSIONS_SUCCESS = 'ASSIGN_ROLE_PERMISSIONS_SUCCESS';
export const ASSIGN_ROLE_PERMISSIONS_FAILURE = 'ASSIGN_ROLE_PERMISSIONS_FAILURE';

export const GET_PERMISSION_CATALOG = 'GET_PERMISSION_CATALOG';
export const GET_PERMISSION_CATALOG_SUCCESS = 'GET_PERMISSION_CATALOG_SUCCESS';
export const GET_PERMISSION_CATALOG_FAILURE = 'GET_PERMISSION_CATALOG_FAILURE';

export const GET_PERMISSION_CATALOG_GROUPED = 'GET_PERMISSION_CATALOG_GROUPED';
export const GET_PERMISSION_CATALOG_GROUPED_SUCCESS = 'GET_PERMISSION_CATALOG_GROUPED_SUCCESS';
export const GET_PERMISSION_CATALOG_GROUPED_FAILURE = 'GET_PERMISSION_CATALOG_GROUPED_FAILURE';

export const CLEAR_SOCIETY_ROLE_DETAILS = 'CLEAR_SOCIETY_ROLE_DETAILS';

// ------ USER ↔ SOCIETY ASSIGNMENT ------------

export const GET_MY_SOCIETIES = 'GET_MY_SOCIETIES';
export const GET_MY_SOCIETIES_SUCCESS = 'GET_MY_SOCIETIES_SUCCESS';
export const GET_MY_SOCIETIES_FAILURE = 'GET_MY_SOCIETIES_FAILURE';

export const GET_MY_PERMISSIONS = 'GET_MY_PERMISSIONS';
export const GET_MY_PERMISSIONS_SUCCESS = 'GET_MY_PERMISSIONS_SUCCESS';
export const GET_MY_PERMISSIONS_FAILURE = 'GET_MY_PERMISSIONS_FAILURE';

export const SET_ACTIVE_SOCIETY = 'SET_ACTIVE_SOCIETY';
export const CLEAR_ACTIVE_SOCIETY = 'CLEAR_ACTIVE_SOCIETY';

export const GET_SOCIETY_USERS = 'GET_SOCIETY_USERS';
export const GET_SOCIETY_USERS_SUCCESS = 'GET_SOCIETY_USERS_SUCCESS';
export const GET_SOCIETY_USERS_FAILURE = 'GET_SOCIETY_USERS_FAILURE';

export const CREATE_USER_SOCIETY = 'CREATE_USER_SOCIETY';
export const CREATE_USER_SOCIETY_SUCCESS = 'CREATE_USER_SOCIETY_SUCCESS';
export const CREATE_USER_SOCIETY_FAILURE = 'CREATE_USER_SOCIETY_FAILURE';

export const UPDATE_USER_SOCIETY = 'UPDATE_USER_SOCIETY';
export const UPDATE_USER_SOCIETY_SUCCESS = 'UPDATE_USER_SOCIETY_SUCCESS';
export const UPDATE_USER_SOCIETY_FAILURE = 'UPDATE_USER_SOCIETY_FAILURE';

export const DELETE_USER_SOCIETY = 'DELETE_USER_SOCIETY';
export const DELETE_USER_SOCIETY_SUCCESS = 'DELETE_USER_SOCIETY_SUCCESS';
export const DELETE_USER_SOCIETY_FAILURE = 'DELETE_USER_SOCIETY_FAILURE';

//------------ DASHBOARD --------------//
export const GET_SOCIETY_DASHBOARD = 'GET_SOCIETY_DASHBOARD';
export const GET_SOCIETY_DASHBOARD_SUCCESS = 'GET_SOCIETY_DASHBOARD_SUCCESS';
export const GET_SOCIETY_DASHBOARD_FAILURE = 'GET_SOCIETY_DASHBOARD_FAILURE';

export const GET_WEBMASTER_DASHBOARD = 'GET_WEBMASTER_DASHBOARD';
export const GET_WEBMASTER_DASHBOARD_SUCCESS = 'GET_WEBMASTER_DASHBOARD_SUCCESS';
export const GET_WEBMASTER_DASHBOARD_FAILURE = 'GET_WEBMASTER_DASHBOARD_FAILURE';

export const GET_OPERATIONS_DASHBOARD = 'GET_OPERATIONS_DASHBOARD';
export const GET_OPERATIONS_DASHBOARD_SUCCESS = 'GET_OPERATIONS_DASHBOARD_SUCCESS';
export const GET_OPERATIONS_DASHBOARD_FAILURE = 'GET_OPERATIONS_DASHBOARD_FAILURE';

export const GET_CTRL_ALL_COMPLAINTS = 'GET_CTRL_ALL_COMPLAINTS';
export const GET_CTRL_ALL_COMPLAINTS_SUCCESS = 'GET_CTRL_ALL_COMPLAINTS_SUCCESS';
export const GET_CTRL_ALL_COMPLAINTS_FAILURE = 'GET_CTRL_ALL_COMPLAINTS_FAILURE';

//------------ COMPLIANCE / FLAT TRANSFER --------------//
export const GET_FLAT_TRANSFER_PREVIEW         = 'GET_FLAT_TRANSFER_PREVIEW';
export const GET_FLAT_TRANSFER_PREVIEW_SUCCESS = 'GET_FLAT_TRANSFER_PREVIEW_SUCCESS';
export const GET_FLAT_TRANSFER_PREVIEW_FAILURE = 'GET_FLAT_TRANSFER_PREVIEW_FAILURE';

export const EXECUTE_FLAT_TRANSFER         = 'EXECUTE_FLAT_TRANSFER';
export const EXECUTE_FLAT_TRANSFER_SUCCESS = 'EXECUTE_FLAT_TRANSFER_SUCCESS';
export const EXECUTE_FLAT_TRANSFER_FAILURE = 'EXECUTE_FLAT_TRANSFER_FAILURE';

export const GET_FLAT_TRANSFER_HISTORY         = 'GET_FLAT_TRANSFER_HISTORY';
export const GET_FLAT_TRANSFER_HISTORY_SUCCESS = 'GET_FLAT_TRANSFER_HISTORY_SUCCESS';
export const GET_FLAT_TRANSFER_HISTORY_FAILURE = 'GET_FLAT_TRANSFER_HISTORY_FAILURE';

export const GET_FLAT_TRANSFER_DETAIL         = 'GET_FLAT_TRANSFER_DETAIL';
export const GET_FLAT_TRANSFER_DETAIL_SUCCESS = 'GET_FLAT_TRANSFER_DETAIL_SUCCESS';
export const GET_FLAT_TRANSFER_DETAIL_FAILURE = 'GET_FLAT_TRANSFER_DETAIL_FAILURE';

export const REVERSE_FLAT_TRANSFER         = 'REVERSE_FLAT_TRANSFER';
export const REVERSE_FLAT_TRANSFER_SUCCESS = 'REVERSE_FLAT_TRANSFER_SUCCESS';
export const REVERSE_FLAT_TRANSFER_FAILURE = 'REVERSE_FLAT_TRANSFER_FAILURE';

export const ADD_FLAT_TRANSFER_DOCUMENT         = 'ADD_FLAT_TRANSFER_DOCUMENT';
export const ADD_FLAT_TRANSFER_DOCUMENT_SUCCESS = 'ADD_FLAT_TRANSFER_DOCUMENT_SUCCESS';
export const ADD_FLAT_TRANSFER_DOCUMENT_FAILURE = 'ADD_FLAT_TRANSFER_DOCUMENT_FAILURE';

//------------ COMPLIANCE / SHARE CERTIFICATE --------------//
export const LIST_SHARE_CERTIFICATES         = 'LIST_SHARE_CERTIFICATES';
export const LIST_SHARE_CERTIFICATES_SUCCESS = 'LIST_SHARE_CERTIFICATES_SUCCESS';
export const LIST_SHARE_CERTIFICATES_FAILURE = 'LIST_SHARE_CERTIFICATES_FAILURE';

export const GET_SHARE_CERTIFICATE         = 'GET_SHARE_CERTIFICATE';
export const GET_SHARE_CERTIFICATE_SUCCESS = 'GET_SHARE_CERTIFICATE_SUCCESS';
export const GET_SHARE_CERTIFICATE_FAILURE = 'GET_SHARE_CERTIFICATE_FAILURE';

export const SET_SHARE_CERTIFICATE_LIEN         = 'SET_SHARE_CERTIFICATE_LIEN';
export const SET_SHARE_CERTIFICATE_LIEN_SUCCESS = 'SET_SHARE_CERTIFICATE_LIEN_SUCCESS';
export const SET_SHARE_CERTIFICATE_LIEN_FAILURE = 'SET_SHARE_CERTIFICATE_LIEN_FAILURE';

//------------ TASK MANAGEMENT --------------//
// Tasks
export const SOCIETY_GET_TASKS_LIST = 'SOCIETY_GET_TASKS_LIST';
export const SOCIETY_GET_TASKS_LIST_SUCCESS = 'SOCIETY_GET_TASKS_LIST_SUCCESS';
export const SOCIETY_GET_TASKS_LIST_FAILURE = 'SOCIETY_GET_TASKS_LIST_FAILURE';

export const SOCIETY_CREATE_TASK = 'SOCIETY_CREATE_TASK';
export const SOCIETY_CREATE_TASK_SUCCESS = 'SOCIETY_CREATE_TASK_SUCCESS';
export const SOCIETY_CREATE_TASK_FAILURE = 'SOCIETY_CREATE_TASK_FAILURE';

export const SOCIETY_GET_TASK_DETAILS = 'SOCIETY_GET_TASK_DETAILS';
export const SOCIETY_GET_TASK_DETAILS_SUCCESS = 'SOCIETY_GET_TASK_DETAILS_SUCCESS';
export const SOCIETY_GET_TASK_DETAILS_FAILURE = 'SOCIETY_GET_TASK_DETAILS_FAILURE';

export const SOCIETY_UPDATE_TASK = 'SOCIETY_UPDATE_TASK';
export const SOCIETY_UPDATE_TASK_SUCCESS = 'SOCIETY_UPDATE_TASK_SUCCESS';
export const SOCIETY_UPDATE_TASK_FAILURE = 'SOCIETY_UPDATE_TASK_FAILURE';

export const SOCIETY_DELETE_TASK = 'SOCIETY_DELETE_TASK';
export const SOCIETY_DELETE_TASK_SUCCESS = 'SOCIETY_DELETE_TASK_SUCCESS';
export const SOCIETY_DELETE_TASK_FAILURE = 'SOCIETY_DELETE_TASK_FAILURE';

export const SOCIETY_CLONE_TASK = 'SOCIETY_CLONE_TASK';
export const SOCIETY_CLONE_TASK_SUCCESS = 'SOCIETY_CLONE_TASK_SUCCESS';
export const SOCIETY_CLONE_TASK_FAILURE = 'SOCIETY_CLONE_TASK_FAILURE';

export const SOCIETY_GET_TASK_HISTORY = 'SOCIETY_GET_TASK_HISTORY';
export const SOCIETY_GET_TASK_HISTORY_SUCCESS = 'SOCIETY_GET_TASK_HISTORY_SUCCESS';
export const SOCIETY_GET_TASK_HISTORY_FAILURE = 'SOCIETY_GET_TASK_HISTORY_FAILURE';

// Workflow
export const SOCIETY_TRANSITION_TASK = 'SOCIETY_TRANSITION_TASK';
export const SOCIETY_TRANSITION_TASK_SUCCESS = 'SOCIETY_TRANSITION_TASK_SUCCESS';
export const SOCIETY_TRANSITION_TASK_FAILURE = 'SOCIETY_TRANSITION_TASK_FAILURE';

export const SOCIETY_CHANGE_TASK_PRIORITY = 'SOCIETY_CHANGE_TASK_PRIORITY';
export const SOCIETY_CHANGE_TASK_PRIORITY_SUCCESS = 'SOCIETY_CHANGE_TASK_PRIORITY_SUCCESS';
export const SOCIETY_CHANGE_TASK_PRIORITY_FAILURE = 'SOCIETY_CHANGE_TASK_PRIORITY_FAILURE';

export const SOCIETY_CHANGE_TASK_TITLE = 'SOCIETY_CHANGE_TASK_TITLE';
export const SOCIETY_CHANGE_TASK_TITLE_SUCCESS = 'SOCIETY_CHANGE_TASK_TITLE_SUCCESS';
export const SOCIETY_CHANGE_TASK_TITLE_FAILURE = 'SOCIETY_CHANGE_TASK_TITLE_FAILURE';

// Assignment
export const SOCIETY_ASSIGN_TASK = 'SOCIETY_ASSIGN_TASK';
export const SOCIETY_ASSIGN_TASK_SUCCESS = 'SOCIETY_ASSIGN_TASK_SUCCESS';
export const SOCIETY_ASSIGN_TASK_FAILURE = 'SOCIETY_ASSIGN_TASK_FAILURE';

export const SOCIETY_SELF_ASSIGN_TASK = 'SOCIETY_SELF_ASSIGN_TASK';
export const SOCIETY_SELF_ASSIGN_TASK_SUCCESS = 'SOCIETY_SELF_ASSIGN_TASK_SUCCESS';
export const SOCIETY_SELF_ASSIGN_TASK_FAILURE = 'SOCIETY_SELF_ASSIGN_TASK_FAILURE';

export const SOCIETY_REASSIGN_TASK = 'SOCIETY_REASSIGN_TASK';
export const SOCIETY_REASSIGN_TASK_SUCCESS = 'SOCIETY_REASSIGN_TASK_SUCCESS';
export const SOCIETY_REASSIGN_TASK_FAILURE = 'SOCIETY_REASSIGN_TASK_FAILURE';

export const SOCIETY_DELEGATE_TASK = 'SOCIETY_DELEGATE_TASK';
export const SOCIETY_DELEGATE_TASK_SUCCESS = 'SOCIETY_DELEGATE_TASK_SUCCESS';
export const SOCIETY_DELEGATE_TASK_FAILURE = 'SOCIETY_DELEGATE_TASK_FAILURE';

export const SOCIETY_REMOVE_TASK_ASSIGNEE = 'SOCIETY_REMOVE_TASK_ASSIGNEE';
export const SOCIETY_REMOVE_TASK_ASSIGNEE_SUCCESS = 'SOCIETY_REMOVE_TASK_ASSIGNEE_SUCCESS';
export const SOCIETY_REMOVE_TASK_ASSIGNEE_FAILURE = 'SOCIETY_REMOVE_TASK_ASSIGNEE_FAILURE';

// Watchers
export const SOCIETY_ADD_TASK_WATCHER = 'SOCIETY_ADD_TASK_WATCHER';
export const SOCIETY_ADD_TASK_WATCHER_SUCCESS = 'SOCIETY_ADD_TASK_WATCHER_SUCCESS';
export const SOCIETY_ADD_TASK_WATCHER_FAILURE = 'SOCIETY_ADD_TASK_WATCHER_FAILURE';

export const SOCIETY_REMOVE_TASK_WATCHER = 'SOCIETY_REMOVE_TASK_WATCHER';
export const SOCIETY_REMOVE_TASK_WATCHER_SUCCESS = 'SOCIETY_REMOVE_TASK_WATCHER_SUCCESS';
export const SOCIETY_REMOVE_TASK_WATCHER_FAILURE = 'SOCIETY_REMOVE_TASK_WATCHER_FAILURE';

// Comments
export const SOCIETY_GET_TASK_COMMENTS = 'SOCIETY_GET_TASK_COMMENTS';
export const SOCIETY_GET_TASK_COMMENTS_SUCCESS = 'SOCIETY_GET_TASK_COMMENTS_SUCCESS';
export const SOCIETY_GET_TASK_COMMENTS_FAILURE = 'SOCIETY_GET_TASK_COMMENTS_FAILURE';

export const SOCIETY_ADD_TASK_COMMENT = 'SOCIETY_ADD_TASK_COMMENT';
export const SOCIETY_ADD_TASK_COMMENT_SUCCESS = 'SOCIETY_ADD_TASK_COMMENT_SUCCESS';
export const SOCIETY_ADD_TASK_COMMENT_FAILURE = 'SOCIETY_ADD_TASK_COMMENT_FAILURE';

export const SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS = 'SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS';
export const SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS_SUCCESS = 'SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS_SUCCESS';
export const SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS_FAILURE = 'SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS_FAILURE';

// Checklist
export const SOCIETY_ADD_TASK_CHECKLIST = 'SOCIETY_ADD_TASK_CHECKLIST';
export const SOCIETY_ADD_TASK_CHECKLIST_SUCCESS = 'SOCIETY_ADD_TASK_CHECKLIST_SUCCESS';
export const SOCIETY_ADD_TASK_CHECKLIST_FAILURE = 'SOCIETY_ADD_TASK_CHECKLIST_FAILURE';

export const SOCIETY_TOGGLE_TASK_CHECKLIST = 'SOCIETY_TOGGLE_TASK_CHECKLIST';
export const SOCIETY_TOGGLE_TASK_CHECKLIST_SUCCESS = 'SOCIETY_TOGGLE_TASK_CHECKLIST_SUCCESS';
export const SOCIETY_TOGGLE_TASK_CHECKLIST_FAILURE = 'SOCIETY_TOGGLE_TASK_CHECKLIST_FAILURE';

export const SOCIETY_DELETE_TASK_CHECKLIST = 'SOCIETY_DELETE_TASK_CHECKLIST';
export const SOCIETY_DELETE_TASK_CHECKLIST_SUCCESS = 'SOCIETY_DELETE_TASK_CHECKLIST_SUCCESS';
export const SOCIETY_DELETE_TASK_CHECKLIST_FAILURE = 'SOCIETY_DELETE_TASK_CHECKLIST_FAILURE';

// Dependencies
export const SOCIETY_ADD_TASK_DEPENDENCY = 'SOCIETY_ADD_TASK_DEPENDENCY';
export const SOCIETY_ADD_TASK_DEPENDENCY_SUCCESS = 'SOCIETY_ADD_TASK_DEPENDENCY_SUCCESS';
export const SOCIETY_ADD_TASK_DEPENDENCY_FAILURE = 'SOCIETY_ADD_TASK_DEPENDENCY_FAILURE';

export const SOCIETY_REMOVE_TASK_DEPENDENCY = 'SOCIETY_REMOVE_TASK_DEPENDENCY';
export const SOCIETY_REMOVE_TASK_DEPENDENCY_SUCCESS = 'SOCIETY_REMOVE_TASK_DEPENDENCY_SUCCESS';
export const SOCIETY_REMOVE_TASK_DEPENDENCY_FAILURE = 'SOCIETY_REMOVE_TASK_DEPENDENCY_FAILURE';

// Attachments
export const SOCIETY_UPLOAD_TASK_ATTACHMENT = 'SOCIETY_UPLOAD_TASK_ATTACHMENT';
export const SOCIETY_UPLOAD_TASK_ATTACHMENT_SUCCESS = 'SOCIETY_UPLOAD_TASK_ATTACHMENT_SUCCESS';
export const SOCIETY_UPLOAD_TASK_ATTACHMENT_FAILURE = 'SOCIETY_UPLOAD_TASK_ATTACHMENT_FAILURE';

export const SOCIETY_DELETE_TASK_ATTACHMENT = 'SOCIETY_DELETE_TASK_ATTACHMENT';
export const SOCIETY_DELETE_TASK_ATTACHMENT_SUCCESS = 'SOCIETY_DELETE_TASK_ATTACHMENT_SUCCESS';
export const SOCIETY_DELETE_TASK_ATTACHMENT_FAILURE = 'SOCIETY_DELETE_TASK_ATTACHMENT_FAILURE';

// Projects
export const SOCIETY_GET_TASK_PROJECTS = 'SOCIETY_GET_TASK_PROJECTS';
export const SOCIETY_GET_TASK_PROJECTS_SUCCESS = 'SOCIETY_GET_TASK_PROJECTS_SUCCESS';
export const SOCIETY_GET_TASK_PROJECTS_FAILURE = 'SOCIETY_GET_TASK_PROJECTS_FAILURE';

export const SOCIETY_CREATE_TASK_PROJECT = 'SOCIETY_CREATE_TASK_PROJECT';
export const SOCIETY_CREATE_TASK_PROJECT_SUCCESS = 'SOCIETY_CREATE_TASK_PROJECT_SUCCESS';
export const SOCIETY_CREATE_TASK_PROJECT_FAILURE = 'SOCIETY_CREATE_TASK_PROJECT_FAILURE';

export const SOCIETY_GET_TASK_PROJECT_DETAILS = 'SOCIETY_GET_TASK_PROJECT_DETAILS';
export const SOCIETY_GET_TASK_PROJECT_DETAILS_SUCCESS = 'SOCIETY_GET_TASK_PROJECT_DETAILS_SUCCESS';
export const SOCIETY_GET_TASK_PROJECT_DETAILS_FAILURE = 'SOCIETY_GET_TASK_PROJECT_DETAILS_FAILURE';

export const SOCIETY_UPDATE_TASK_PROJECT = 'SOCIETY_UPDATE_TASK_PROJECT';
export const SOCIETY_UPDATE_TASK_PROJECT_SUCCESS = 'SOCIETY_UPDATE_TASK_PROJECT_SUCCESS';
export const SOCIETY_UPDATE_TASK_PROJECT_FAILURE = 'SOCIETY_UPDATE_TASK_PROJECT_FAILURE';

export const SOCIETY_DELETE_TASK_PROJECT = 'SOCIETY_DELETE_TASK_PROJECT';
export const SOCIETY_DELETE_TASK_PROJECT_SUCCESS = 'SOCIETY_DELETE_TASK_PROJECT_SUCCESS';
export const SOCIETY_DELETE_TASK_PROJECT_FAILURE = 'SOCIETY_DELETE_TASK_PROJECT_FAILURE';

// Collection
export const SOCIETY_BULK_CREATE_TASKS = 'SOCIETY_BULK_CREATE_TASKS';
export const SOCIETY_BULK_CREATE_TASKS_SUCCESS = 'SOCIETY_BULK_CREATE_TASKS_SUCCESS';
export const SOCIETY_BULK_CREATE_TASKS_FAILURE = 'SOCIETY_BULK_CREATE_TASKS_FAILURE';

export const SOCIETY_GET_TASK_DASHBOARD = 'SOCIETY_GET_TASK_DASHBOARD';
export const SOCIETY_GET_TASK_DASHBOARD_SUCCESS = 'SOCIETY_GET_TASK_DASHBOARD_SUCCESS';
export const SOCIETY_GET_TASK_DASHBOARD_FAILURE = 'SOCIETY_GET_TASK_DASHBOARD_FAILURE';

// ============ NOTICES & CIRCULARS ============
export const SOCIETY_GET_NOTICES_LIST = 'SOCIETY_GET_NOTICES_LIST';
export const SOCIETY_GET_NOTICES_LIST_SUCCESS = 'SOCIETY_GET_NOTICES_LIST_SUCCESS';
export const SOCIETY_GET_NOTICES_LIST_FAILURE = 'SOCIETY_GET_NOTICES_LIST_FAILURE';

export const SOCIETY_GET_NOTICE_DETAILS = 'SOCIETY_GET_NOTICE_DETAILS';
export const SOCIETY_GET_NOTICE_DETAILS_SUCCESS = 'SOCIETY_GET_NOTICE_DETAILS_SUCCESS';
export const SOCIETY_GET_NOTICE_DETAILS_FAILURE = 'SOCIETY_GET_NOTICE_DETAILS_FAILURE';

export const SOCIETY_CREATE_NOTICE = 'SOCIETY_CREATE_NOTICE';
export const SOCIETY_CREATE_NOTICE_SUCCESS = 'SOCIETY_CREATE_NOTICE_SUCCESS';
export const SOCIETY_CREATE_NOTICE_FAILURE = 'SOCIETY_CREATE_NOTICE_FAILURE';

export const SOCIETY_UPDATE_NOTICE = 'SOCIETY_UPDATE_NOTICE';
export const SOCIETY_UPDATE_NOTICE_SUCCESS = 'SOCIETY_UPDATE_NOTICE_SUCCESS';
export const SOCIETY_UPDATE_NOTICE_FAILURE = 'SOCIETY_UPDATE_NOTICE_FAILURE';

export const SOCIETY_DELETE_NOTICE = 'SOCIETY_DELETE_NOTICE';
export const SOCIETY_DELETE_NOTICE_SUCCESS = 'SOCIETY_DELETE_NOTICE_SUCCESS';
export const SOCIETY_DELETE_NOTICE_FAILURE = 'SOCIETY_DELETE_NOTICE_FAILURE';

export const SOCIETY_PUBLISH_NOTICE = 'SOCIETY_PUBLISH_NOTICE';
export const SOCIETY_PUBLISH_NOTICE_SUCCESS = 'SOCIETY_PUBLISH_NOTICE_SUCCESS';
export const SOCIETY_PUBLISH_NOTICE_FAILURE = 'SOCIETY_PUBLISH_NOTICE_FAILURE';

export const SOCIETY_ARCHIVE_NOTICE = 'SOCIETY_ARCHIVE_NOTICE';
export const SOCIETY_ARCHIVE_NOTICE_SUCCESS = 'SOCIETY_ARCHIVE_NOTICE_SUCCESS';
export const SOCIETY_ARCHIVE_NOTICE_FAILURE = 'SOCIETY_ARCHIVE_NOTICE_FAILURE';

export const SOCIETY_UPLOAD_NOTICE_ATTACHMENTS = 'SOCIETY_UPLOAD_NOTICE_ATTACHMENTS';
export const SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_SUCCESS = 'SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_SUCCESS';
export const SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_FAILURE = 'SOCIETY_UPLOAD_NOTICE_ATTACHMENTS_FAILURE';

export const SOCIETY_DELETE_NOTICE_ATTACHMENT = 'SOCIETY_DELETE_NOTICE_ATTACHMENT';
export const SOCIETY_DELETE_NOTICE_ATTACHMENT_SUCCESS = 'SOCIETY_DELETE_NOTICE_ATTACHMENT_SUCCESS';
export const SOCIETY_DELETE_NOTICE_ATTACHMENT_FAILURE = 'SOCIETY_DELETE_NOTICE_ATTACHMENT_FAILURE';

export const SOCIETY_ACKNOWLEDGE_NOTICE = 'SOCIETY_ACKNOWLEDGE_NOTICE';
export const SOCIETY_ACKNOWLEDGE_NOTICE_SUCCESS = 'SOCIETY_ACKNOWLEDGE_NOTICE_SUCCESS';
export const SOCIETY_ACKNOWLEDGE_NOTICE_FAILURE = 'SOCIETY_ACKNOWLEDGE_NOTICE_FAILURE';

export const SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS = 'SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS';
export const SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_SUCCESS = 'SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_SUCCESS';
export const SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_FAILURE = 'SOCIETY_GET_NOTICE_ACKNOWLEDGEMENTS_FAILURE';

export const SOCIETY_GET_NOTICE_ENUMS = 'SOCIETY_GET_NOTICE_ENUMS';
export const SOCIETY_GET_NOTICE_ENUMS_SUCCESS = 'SOCIETY_GET_NOTICE_ENUMS_SUCCESS';
export const SOCIETY_GET_NOTICE_ENUMS_FAILURE = 'SOCIETY_GET_NOTICE_ENUMS_FAILURE';

export const SOCIETY_GET_NOTICE_STATS = 'SOCIETY_GET_NOTICE_STATS';
export const SOCIETY_GET_NOTICE_STATS_SUCCESS = 'SOCIETY_GET_NOTICE_STATS_SUCCESS';
export const SOCIETY_GET_NOTICE_STATS_FAILURE = 'SOCIETY_GET_NOTICE_STATS_FAILURE';

export const SOCIETY_GET_NOTICE_BOARD = 'SOCIETY_GET_NOTICE_BOARD';
export const SOCIETY_GET_NOTICE_BOARD_SUCCESS = 'SOCIETY_GET_NOTICE_BOARD_SUCCESS';
export const SOCIETY_GET_NOTICE_BOARD_FAILURE = 'SOCIETY_GET_NOTICE_BOARD_FAILURE';

export const SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS = 'SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS';
export const SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_SUCCESS = 'SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_SUCCESS';
export const SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_FAILURE = 'SOCIETY_GET_NOTICE_AUDIENCE_OPTIONS_FAILURE';

// ============ VISITOR MANAGEMENT (VMS) ============
export const SOCIETY_GET_VISITORS_LIST = 'SOCIETY_GET_VISITORS_LIST';
export const SOCIETY_GET_VISITORS_LIST_SUCCESS = 'SOCIETY_GET_VISITORS_LIST_SUCCESS';
export const SOCIETY_GET_VISITORS_LIST_FAILURE = 'SOCIETY_GET_VISITORS_LIST_FAILURE';

export const SOCIETY_GET_VISITOR_DETAILS = 'SOCIETY_GET_VISITOR_DETAILS';
export const SOCIETY_GET_VISITOR_DETAILS_SUCCESS = 'SOCIETY_GET_VISITOR_DETAILS_SUCCESS';
export const SOCIETY_GET_VISITOR_DETAILS_FAILURE = 'SOCIETY_GET_VISITOR_DETAILS_FAILURE';

export const SOCIETY_CREATE_VISITOR = 'SOCIETY_CREATE_VISITOR';
export const SOCIETY_CREATE_VISITOR_SUCCESS = 'SOCIETY_CREATE_VISITOR_SUCCESS';
export const SOCIETY_CREATE_VISITOR_FAILURE = 'SOCIETY_CREATE_VISITOR_FAILURE';

export const SOCIETY_UPDATE_VISITOR = 'SOCIETY_UPDATE_VISITOR';
export const SOCIETY_UPDATE_VISITOR_SUCCESS = 'SOCIETY_UPDATE_VISITOR_SUCCESS';
export const SOCIETY_UPDATE_VISITOR_FAILURE = 'SOCIETY_UPDATE_VISITOR_FAILURE';

export const SOCIETY_DELETE_VISITOR = 'SOCIETY_DELETE_VISITOR';
export const SOCIETY_DELETE_VISITOR_SUCCESS = 'SOCIETY_DELETE_VISITOR_SUCCESS';
export const SOCIETY_DELETE_VISITOR_FAILURE = 'SOCIETY_DELETE_VISITOR_FAILURE';

export const SOCIETY_BLOCK_VISITOR = 'SOCIETY_BLOCK_VISITOR';
export const SOCIETY_BLOCK_VISITOR_SUCCESS = 'SOCIETY_BLOCK_VISITOR_SUCCESS';
export const SOCIETY_BLOCK_VISITOR_FAILURE = 'SOCIETY_BLOCK_VISITOR_FAILURE';

export const SOCIETY_UNBLOCK_VISITOR = 'SOCIETY_UNBLOCK_VISITOR';
export const SOCIETY_UNBLOCK_VISITOR_SUCCESS = 'SOCIETY_UNBLOCK_VISITOR_SUCCESS';
export const SOCIETY_UNBLOCK_VISITOR_FAILURE = 'SOCIETY_UNBLOCK_VISITOR_FAILURE';

// Derived counters for the list banner. There is no /api/visitors/stats yet, so
// the saga fans out cheap limit=1 list calls and reads meta.pagination.total.
export const SOCIETY_GET_VISITOR_SUMMARY = 'SOCIETY_GET_VISITOR_SUMMARY';
export const SOCIETY_GET_VISITOR_SUMMARY_SUCCESS = 'SOCIETY_GET_VISITOR_SUMMARY_SUCCESS';
export const SOCIETY_GET_VISITOR_SUMMARY_FAILURE = 'SOCIETY_GET_VISITOR_SUMMARY_FAILURE';

// ============ VMS: VISITS ============
export const SOCIETY_GET_VISITS_LIST = 'SOCIETY_GET_VISITS_LIST';
export const SOCIETY_GET_VISITS_LIST_SUCCESS = 'SOCIETY_GET_VISITS_LIST_SUCCESS';
export const SOCIETY_GET_VISITS_LIST_FAILURE = 'SOCIETY_GET_VISITS_LIST_FAILURE';

export const SOCIETY_GET_VISIT_DETAILS = 'SOCIETY_GET_VISIT_DETAILS';
export const SOCIETY_GET_VISIT_DETAILS_SUCCESS = 'SOCIETY_GET_VISIT_DETAILS_SUCCESS';
export const SOCIETY_GET_VISIT_DETAILS_FAILURE = 'SOCIETY_GET_VISIT_DETAILS_FAILURE';

export const SOCIETY_CREATE_VISIT = 'SOCIETY_CREATE_VISIT';
export const SOCIETY_CREATE_VISIT_SUCCESS = 'SOCIETY_CREATE_VISIT_SUCCESS';
export const SOCIETY_CREATE_VISIT_FAILURE = 'SOCIETY_CREATE_VISIT_FAILURE';

export const SOCIETY_UPDATE_VISIT = 'SOCIETY_UPDATE_VISIT';
export const SOCIETY_UPDATE_VISIT_SUCCESS = 'SOCIETY_UPDATE_VISIT_SUCCESS';
export const SOCIETY_UPDATE_VISIT_FAILURE = 'SOCIETY_UPDATE_VISIT_FAILURE';

export const SOCIETY_DELETE_VISIT = 'SOCIETY_DELETE_VISIT';
export const SOCIETY_DELETE_VISIT_SUCCESS = 'SOCIETY_DELETE_VISIT_SUCCESS';
export const SOCIETY_DELETE_VISIT_FAILURE = 'SOCIETY_DELETE_VISIT_FAILURE';

export const SOCIETY_APPROVE_VISIT = 'SOCIETY_APPROVE_VISIT';
export const SOCIETY_APPROVE_VISIT_SUCCESS = 'SOCIETY_APPROVE_VISIT_SUCCESS';
export const SOCIETY_APPROVE_VISIT_FAILURE = 'SOCIETY_APPROVE_VISIT_FAILURE';

export const SOCIETY_REJECT_VISIT = 'SOCIETY_REJECT_VISIT';
export const SOCIETY_REJECT_VISIT_SUCCESS = 'SOCIETY_REJECT_VISIT_SUCCESS';
export const SOCIETY_REJECT_VISIT_FAILURE = 'SOCIETY_REJECT_VISIT_FAILURE';

export const SOCIETY_VERIFY_VISIT_OTP = 'SOCIETY_VERIFY_VISIT_OTP';
export const SOCIETY_VERIFY_VISIT_OTP_SUCCESS = 'SOCIETY_VERIFY_VISIT_OTP_SUCCESS';
export const SOCIETY_VERIFY_VISIT_OTP_FAILURE = 'SOCIETY_VERIFY_VISIT_OTP_FAILURE';

export const SOCIETY_CHECK_IN_VISIT = 'SOCIETY_CHECK_IN_VISIT';
export const SOCIETY_CHECK_IN_VISIT_SUCCESS = 'SOCIETY_CHECK_IN_VISIT_SUCCESS';
export const SOCIETY_CHECK_IN_VISIT_FAILURE = 'SOCIETY_CHECK_IN_VISIT_FAILURE';

export const SOCIETY_CHECK_OUT_VISIT = 'SOCIETY_CHECK_OUT_VISIT';
export const SOCIETY_CHECK_OUT_VISIT_SUCCESS = 'SOCIETY_CHECK_OUT_VISIT_SUCCESS';
export const SOCIETY_CHECK_OUT_VISIT_FAILURE = 'SOCIETY_CHECK_OUT_VISIT_FAILURE';

// ============ VMS: PRE-APPROVALS ============
export const SOCIETY_GET_PRE_APPROVALS_LIST = 'SOCIETY_GET_PRE_APPROVALS_LIST';
export const SOCIETY_GET_PRE_APPROVALS_LIST_SUCCESS = 'SOCIETY_GET_PRE_APPROVALS_LIST_SUCCESS';
export const SOCIETY_GET_PRE_APPROVALS_LIST_FAILURE = 'SOCIETY_GET_PRE_APPROVALS_LIST_FAILURE';

export const SOCIETY_GET_PRE_APPROVAL_DETAILS = 'SOCIETY_GET_PRE_APPROVAL_DETAILS';
export const SOCIETY_GET_PRE_APPROVAL_DETAILS_SUCCESS = 'SOCIETY_GET_PRE_APPROVAL_DETAILS_SUCCESS';
export const SOCIETY_GET_PRE_APPROVAL_DETAILS_FAILURE = 'SOCIETY_GET_PRE_APPROVAL_DETAILS_FAILURE';

export const SOCIETY_CREATE_PRE_APPROVAL = 'SOCIETY_CREATE_PRE_APPROVAL';
export const SOCIETY_CREATE_PRE_APPROVAL_SUCCESS = 'SOCIETY_CREATE_PRE_APPROVAL_SUCCESS';
export const SOCIETY_CREATE_PRE_APPROVAL_FAILURE = 'SOCIETY_CREATE_PRE_APPROVAL_FAILURE';

export const SOCIETY_UPDATE_PRE_APPROVAL = 'SOCIETY_UPDATE_PRE_APPROVAL';
export const SOCIETY_UPDATE_PRE_APPROVAL_SUCCESS = 'SOCIETY_UPDATE_PRE_APPROVAL_SUCCESS';
export const SOCIETY_UPDATE_PRE_APPROVAL_FAILURE = 'SOCIETY_UPDATE_PRE_APPROVAL_FAILURE';

export const SOCIETY_DELETE_PRE_APPROVAL = 'SOCIETY_DELETE_PRE_APPROVAL';
export const SOCIETY_DELETE_PRE_APPROVAL_SUCCESS = 'SOCIETY_DELETE_PRE_APPROVAL_SUCCESS';
export const SOCIETY_DELETE_PRE_APPROVAL_FAILURE = 'SOCIETY_DELETE_PRE_APPROVAL_FAILURE';

// ============ VMS: GATE PASSES ============
export const SOCIETY_GET_GATE_PASSES_LIST = 'SOCIETY_GET_GATE_PASSES_LIST';
export const SOCIETY_GET_GATE_PASSES_LIST_SUCCESS = 'SOCIETY_GET_GATE_PASSES_LIST_SUCCESS';
export const SOCIETY_GET_GATE_PASSES_LIST_FAILURE = 'SOCIETY_GET_GATE_PASSES_LIST_FAILURE';

export const SOCIETY_GET_GATE_PASS_DETAILS = 'SOCIETY_GET_GATE_PASS_DETAILS';
export const SOCIETY_GET_GATE_PASS_DETAILS_SUCCESS = 'SOCIETY_GET_GATE_PASS_DETAILS_SUCCESS';
export const SOCIETY_GET_GATE_PASS_DETAILS_FAILURE = 'SOCIETY_GET_GATE_PASS_DETAILS_FAILURE';

export const SOCIETY_CREATE_GATE_PASS = 'SOCIETY_CREATE_GATE_PASS';
export const SOCIETY_CREATE_GATE_PASS_SUCCESS = 'SOCIETY_CREATE_GATE_PASS_SUCCESS';
export const SOCIETY_CREATE_GATE_PASS_FAILURE = 'SOCIETY_CREATE_GATE_PASS_FAILURE';

export const SOCIETY_UPDATE_GATE_PASS = 'SOCIETY_UPDATE_GATE_PASS';
export const SOCIETY_UPDATE_GATE_PASS_SUCCESS = 'SOCIETY_UPDATE_GATE_PASS_SUCCESS';
export const SOCIETY_UPDATE_GATE_PASS_FAILURE = 'SOCIETY_UPDATE_GATE_PASS_FAILURE';

export const SOCIETY_DELETE_GATE_PASS = 'SOCIETY_DELETE_GATE_PASS';
export const SOCIETY_DELETE_GATE_PASS_SUCCESS = 'SOCIETY_DELETE_GATE_PASS_SUCCESS';
export const SOCIETY_DELETE_GATE_PASS_FAILURE = 'SOCIETY_DELETE_GATE_PASS_FAILURE';

export const SOCIETY_REVOKE_GATE_PASS = 'SOCIETY_REVOKE_GATE_PASS';
export const SOCIETY_REVOKE_GATE_PASS_SUCCESS = 'SOCIETY_REVOKE_GATE_PASS_SUCCESS';
export const SOCIETY_REVOKE_GATE_PASS_FAILURE = 'SOCIETY_REVOKE_GATE_PASS_FAILURE';

// ============ VMS: DELIVERY LOGS ============
export const SOCIETY_GET_DELIVERIES_LIST = 'SOCIETY_GET_DELIVERIES_LIST';
export const SOCIETY_GET_DELIVERIES_LIST_SUCCESS = 'SOCIETY_GET_DELIVERIES_LIST_SUCCESS';
export const SOCIETY_GET_DELIVERIES_LIST_FAILURE = 'SOCIETY_GET_DELIVERIES_LIST_FAILURE';

export const SOCIETY_GET_DELIVERY_DETAILS = 'SOCIETY_GET_DELIVERY_DETAILS';
export const SOCIETY_GET_DELIVERY_DETAILS_SUCCESS = 'SOCIETY_GET_DELIVERY_DETAILS_SUCCESS';
export const SOCIETY_GET_DELIVERY_DETAILS_FAILURE = 'SOCIETY_GET_DELIVERY_DETAILS_FAILURE';

export const SOCIETY_CREATE_DELIVERY = 'SOCIETY_CREATE_DELIVERY';
export const SOCIETY_CREATE_DELIVERY_SUCCESS = 'SOCIETY_CREATE_DELIVERY_SUCCESS';
export const SOCIETY_CREATE_DELIVERY_FAILURE = 'SOCIETY_CREATE_DELIVERY_FAILURE';

export const SOCIETY_UPDATE_DELIVERY = 'SOCIETY_UPDATE_DELIVERY';
export const SOCIETY_UPDATE_DELIVERY_SUCCESS = 'SOCIETY_UPDATE_DELIVERY_SUCCESS';
export const SOCIETY_UPDATE_DELIVERY_FAILURE = 'SOCIETY_UPDATE_DELIVERY_FAILURE';

export const SOCIETY_DELETE_DELIVERY = 'SOCIETY_DELETE_DELIVERY';
export const SOCIETY_DELETE_DELIVERY_SUCCESS = 'SOCIETY_DELETE_DELIVERY_SUCCESS';
export const SOCIETY_DELETE_DELIVERY_FAILURE = 'SOCIETY_DELETE_DELIVERY_FAILURE';

export const SOCIETY_COMPLETE_DELIVERY = 'SOCIETY_COMPLETE_DELIVERY';
export const SOCIETY_COMPLETE_DELIVERY_SUCCESS = 'SOCIETY_COMPLETE_DELIVERY_SUCCESS';
export const SOCIETY_COMPLETE_DELIVERY_FAILURE = 'SOCIETY_COMPLETE_DELIVERY_FAILURE';

// ============ VMS: CAB LOGS ============
export const SOCIETY_GET_CABS_LIST = 'SOCIETY_GET_CABS_LIST';
export const SOCIETY_GET_CABS_LIST_SUCCESS = 'SOCIETY_GET_CABS_LIST_SUCCESS';
export const SOCIETY_GET_CABS_LIST_FAILURE = 'SOCIETY_GET_CABS_LIST_FAILURE';

export const SOCIETY_GET_CAB_DETAILS = 'SOCIETY_GET_CAB_DETAILS';
export const SOCIETY_GET_CAB_DETAILS_SUCCESS = 'SOCIETY_GET_CAB_DETAILS_SUCCESS';
export const SOCIETY_GET_CAB_DETAILS_FAILURE = 'SOCIETY_GET_CAB_DETAILS_FAILURE';

export const SOCIETY_CREATE_CAB = 'SOCIETY_CREATE_CAB';
export const SOCIETY_CREATE_CAB_SUCCESS = 'SOCIETY_CREATE_CAB_SUCCESS';
export const SOCIETY_CREATE_CAB_FAILURE = 'SOCIETY_CREATE_CAB_FAILURE';

export const SOCIETY_UPDATE_CAB = 'SOCIETY_UPDATE_CAB';
export const SOCIETY_UPDATE_CAB_SUCCESS = 'SOCIETY_UPDATE_CAB_SUCCESS';
export const SOCIETY_UPDATE_CAB_FAILURE = 'SOCIETY_UPDATE_CAB_FAILURE';

export const SOCIETY_DELETE_CAB = 'SOCIETY_DELETE_CAB';
export const SOCIETY_DELETE_CAB_SUCCESS = 'SOCIETY_DELETE_CAB_SUCCESS';
export const SOCIETY_DELETE_CAB_FAILURE = 'SOCIETY_DELETE_CAB_FAILURE';

export const SOCIETY_COMPLETE_CAB = 'SOCIETY_COMPLETE_CAB';
export const SOCIETY_COMPLETE_CAB_SUCCESS = 'SOCIETY_COMPLETE_CAB_SUCCESS';
export const SOCIETY_COMPLETE_CAB_FAILURE = 'SOCIETY_COMPLETE_CAB_FAILURE';

// ============ VMS: ACTIVITY LOGS ============
export const SOCIETY_GET_VMS_ACTIVITY_LOGS = 'SOCIETY_GET_VMS_ACTIVITY_LOGS';
export const SOCIETY_GET_VMS_ACTIVITY_LOGS_SUCCESS = 'SOCIETY_GET_VMS_ACTIVITY_LOGS_SUCCESS';
export const SOCIETY_GET_VMS_ACTIVITY_LOGS_FAILURE = 'SOCIETY_GET_VMS_ACTIVITY_LOGS_FAILURE';

export const SOCIETY_EXPORT_VMS_ACTIVITY_LOGS = 'SOCIETY_EXPORT_VMS_ACTIVITY_LOGS';
export const SOCIETY_EXPORT_VMS_ACTIVITY_LOGS_SUCCESS = 'SOCIETY_EXPORT_VMS_ACTIVITY_LOGS_SUCCESS';
export const SOCIETY_EXPORT_VMS_ACTIVITY_LOGS_FAILURE = 'SOCIETY_EXPORT_VMS_ACTIVITY_LOGS_FAILURE';

// ============ VMS: SETTINGS ============
export const SOCIETY_GET_VMS_SETTINGS = 'SOCIETY_GET_VMS_SETTINGS';
export const SOCIETY_GET_VMS_SETTINGS_SUCCESS = 'SOCIETY_GET_VMS_SETTINGS_SUCCESS';
export const SOCIETY_GET_VMS_SETTINGS_FAILURE = 'SOCIETY_GET_VMS_SETTINGS_FAILURE';

export const SOCIETY_UPDATE_VMS_SETTINGS = 'SOCIETY_UPDATE_VMS_SETTINGS';
export const SOCIETY_UPDATE_VMS_SETTINGS_SUCCESS = 'SOCIETY_UPDATE_VMS_SETTINGS_SUCCESS';
export const SOCIETY_UPDATE_VMS_SETTINGS_FAILURE = 'SOCIETY_UPDATE_VMS_SETTINGS_FAILURE';
export const SOCIETY_RESEND_NOTICE = 'SOCIETY_RESEND_NOTICE';
export const SOCIETY_RESEND_NOTICE_SUCCESS = 'SOCIETY_RESEND_NOTICE_SUCCESS';
export const SOCIETY_RESEND_NOTICE_FAILURE = 'SOCIETY_RESEND_NOTICE_FAILURE';

export const SOCIETY_GET_NOTICE_COMMENTS = 'SOCIETY_GET_NOTICE_COMMENTS';
export const SOCIETY_GET_NOTICE_COMMENTS_SUCCESS = 'SOCIETY_GET_NOTICE_COMMENTS_SUCCESS';
export const SOCIETY_GET_NOTICE_COMMENTS_FAILURE = 'SOCIETY_GET_NOTICE_COMMENTS_FAILURE';

export const SOCIETY_ADD_NOTICE_COMMENT = 'SOCIETY_ADD_NOTICE_COMMENT';
export const SOCIETY_ADD_NOTICE_COMMENT_SUCCESS = 'SOCIETY_ADD_NOTICE_COMMENT_SUCCESS';
export const SOCIETY_ADD_NOTICE_COMMENT_FAILURE = 'SOCIETY_ADD_NOTICE_COMMENT_FAILURE';

export const SOCIETY_DELETE_NOTICE_COMMENT = 'SOCIETY_DELETE_NOTICE_COMMENT';
export const SOCIETY_DELETE_NOTICE_COMMENT_SUCCESS = 'SOCIETY_DELETE_NOTICE_COMMENT_SUCCESS';
export const SOCIETY_DELETE_NOTICE_COMMENT_FAILURE = 'SOCIETY_DELETE_NOTICE_COMMENT_FAILURE';
// ========== MEMBER SELF-SERVICE (My Home) ==========
// Reads against the /api/member/* namespace. Kept in their own slice so a member
// opening My Bills never clobbers the admin invoice list someone was filtering,
// the same way the notice board sits beside the admin notices list.
export const MEMBER_GET_SUMMARY = 'MEMBER_GET_SUMMARY';
export const MEMBER_GET_SUMMARY_SUCCESS = 'MEMBER_GET_SUMMARY_SUCCESS';
export const MEMBER_GET_SUMMARY_FAILURE = 'MEMBER_GET_SUMMARY_FAILURE';

export const MEMBER_GET_FLATS = 'MEMBER_GET_FLATS';
export const MEMBER_GET_FLATS_SUCCESS = 'MEMBER_GET_FLATS_SUCCESS';
export const MEMBER_GET_FLATS_FAILURE = 'MEMBER_GET_FLATS_FAILURE';

export const MEMBER_GET_INVOICES = 'MEMBER_GET_INVOICES';
export const MEMBER_GET_INVOICES_SUCCESS = 'MEMBER_GET_INVOICES_SUCCESS';
export const MEMBER_GET_INVOICES_FAILURE = 'MEMBER_GET_INVOICES_FAILURE';

export const MEMBER_GET_INVOICE_DETAILS = 'MEMBER_GET_INVOICE_DETAILS';
export const MEMBER_GET_INVOICE_DETAILS_SUCCESS = 'MEMBER_GET_INVOICE_DETAILS_SUCCESS';
export const MEMBER_GET_INVOICE_DETAILS_FAILURE = 'MEMBER_GET_INVOICE_DETAILS_FAILURE';

export const MEMBER_GET_PAYMENTS = 'MEMBER_GET_PAYMENTS';
export const MEMBER_GET_PAYMENTS_SUCCESS = 'MEMBER_GET_PAYMENTS_SUCCESS';
export const MEMBER_GET_PAYMENTS_FAILURE = 'MEMBER_GET_PAYMENTS_FAILURE';

export const MEMBER_GET_PAYMENT_DETAILS = 'MEMBER_GET_PAYMENT_DETAILS';
export const MEMBER_GET_PAYMENT_DETAILS_SUCCESS = 'MEMBER_GET_PAYMENT_DETAILS_SUCCESS';
export const MEMBER_GET_PAYMENT_DETAILS_FAILURE = 'MEMBER_GET_PAYMENT_DETAILS_FAILURE';

export const MEMBER_GET_LEDGER = 'MEMBER_GET_LEDGER';
export const MEMBER_GET_LEDGER_SUCCESS = 'MEMBER_GET_LEDGER_SUCCESS';
export const MEMBER_GET_LEDGER_FAILURE = 'MEMBER_GET_LEDGER_FAILURE';

// ===== Employee Shifts =====

// Shift definitions — /api/shifts
export const SOCIETY_GET_SHIFT_ENUMS = 'SOCIETY_GET_SHIFT_ENUMS';
export const SOCIETY_GET_SHIFT_ENUMS_SUCCESS = 'SOCIETY_GET_SHIFT_ENUMS_SUCCESS';
export const SOCIETY_GET_SHIFT_ENUMS_FAILURE = 'SOCIETY_GET_SHIFT_ENUMS_FAILURE';

export const SOCIETY_GET_SHIFTS = 'SOCIETY_GET_SHIFTS';
export const SOCIETY_GET_SHIFTS_SUCCESS = 'SOCIETY_GET_SHIFTS_SUCCESS';
export const SOCIETY_GET_SHIFTS_FAILURE = 'SOCIETY_GET_SHIFTS_FAILURE';

export const SOCIETY_GET_SHIFT_DETAILS = 'SOCIETY_GET_SHIFT_DETAILS';
export const SOCIETY_GET_SHIFT_DETAILS_SUCCESS = 'SOCIETY_GET_SHIFT_DETAILS_SUCCESS';
export const SOCIETY_GET_SHIFT_DETAILS_FAILURE = 'SOCIETY_GET_SHIFT_DETAILS_FAILURE';

export const SOCIETY_CREATE_SHIFT = 'SOCIETY_CREATE_SHIFT';
export const SOCIETY_CREATE_SHIFT_SUCCESS = 'SOCIETY_CREATE_SHIFT_SUCCESS';
export const SOCIETY_CREATE_SHIFT_FAILURE = 'SOCIETY_CREATE_SHIFT_FAILURE';

export const SOCIETY_UPDATE_SHIFT = 'SOCIETY_UPDATE_SHIFT';
export const SOCIETY_UPDATE_SHIFT_SUCCESS = 'SOCIETY_UPDATE_SHIFT_SUCCESS';
export const SOCIETY_UPDATE_SHIFT_FAILURE = 'SOCIETY_UPDATE_SHIFT_FAILURE';

export const SOCIETY_DELETE_SHIFT = 'SOCIETY_DELETE_SHIFT';
export const SOCIETY_DELETE_SHIFT_SUCCESS = 'SOCIETY_DELETE_SHIFT_SUCCESS';
export const SOCIETY_DELETE_SHIFT_FAILURE = 'SOCIETY_DELETE_SHIFT_FAILURE';

// Shift assignments — /api/shift-assignments
export const SOCIETY_GET_SHIFT_ASSIGNMENTS = 'SOCIETY_GET_SHIFT_ASSIGNMENTS';
export const SOCIETY_GET_SHIFT_ASSIGNMENTS_SUCCESS = 'SOCIETY_GET_SHIFT_ASSIGNMENTS_SUCCESS';
export const SOCIETY_GET_SHIFT_ASSIGNMENTS_FAILURE = 'SOCIETY_GET_SHIFT_ASSIGNMENTS_FAILURE';

export const SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS = 'SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS';
export const SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS_SUCCESS = 'SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS_SUCCESS';
export const SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS_FAILURE = 'SOCIETY_GET_SHIFT_ASSIGNMENT_DETAILS_FAILURE';

export const SOCIETY_CREATE_SHIFT_ASSIGNMENT = 'SOCIETY_CREATE_SHIFT_ASSIGNMENT';
export const SOCIETY_CREATE_SHIFT_ASSIGNMENT_SUCCESS = 'SOCIETY_CREATE_SHIFT_ASSIGNMENT_SUCCESS';
export const SOCIETY_CREATE_SHIFT_ASSIGNMENT_FAILURE = 'SOCIETY_CREATE_SHIFT_ASSIGNMENT_FAILURE';

export const SOCIETY_UPDATE_SHIFT_ASSIGNMENT = 'SOCIETY_UPDATE_SHIFT_ASSIGNMENT';
export const SOCIETY_UPDATE_SHIFT_ASSIGNMENT_SUCCESS = 'SOCIETY_UPDATE_SHIFT_ASSIGNMENT_SUCCESS';
export const SOCIETY_UPDATE_SHIFT_ASSIGNMENT_FAILURE = 'SOCIETY_UPDATE_SHIFT_ASSIGNMENT_FAILURE';

export const SOCIETY_END_SHIFT_ASSIGNMENT = 'SOCIETY_END_SHIFT_ASSIGNMENT';
export const SOCIETY_END_SHIFT_ASSIGNMENT_SUCCESS = 'SOCIETY_END_SHIFT_ASSIGNMENT_SUCCESS';
export const SOCIETY_END_SHIFT_ASSIGNMENT_FAILURE = 'SOCIETY_END_SHIFT_ASSIGNMENT_FAILURE';

export const SOCIETY_DELETE_SHIFT_ASSIGNMENT = 'SOCIETY_DELETE_SHIFT_ASSIGNMENT';
export const SOCIETY_DELETE_SHIFT_ASSIGNMENT_SUCCESS = 'SOCIETY_DELETE_SHIFT_ASSIGNMENT_SUCCESS';
export const SOCIETY_DELETE_SHIFT_ASSIGNMENT_FAILURE = 'SOCIETY_DELETE_SHIFT_ASSIGNMENT_FAILURE';

// Resident complaints, on /api/member/complaints* (member_portal.complaints)
export const MEMBER_GET_COMPLAINTS = 'MEMBER_GET_COMPLAINTS';
export const MEMBER_GET_COMPLAINTS_SUCCESS = 'MEMBER_GET_COMPLAINTS_SUCCESS';
export const MEMBER_GET_COMPLAINTS_FAILURE = 'MEMBER_GET_COMPLAINTS_FAILURE';

export const MEMBER_GET_COMPLAINT_DETAILS = 'MEMBER_GET_COMPLAINT_DETAILS';
export const MEMBER_GET_COMPLAINT_DETAILS_SUCCESS = 'MEMBER_GET_COMPLAINT_DETAILS_SUCCESS';
export const MEMBER_GET_COMPLAINT_DETAILS_FAILURE = 'MEMBER_GET_COMPLAINT_DETAILS_FAILURE';

export const MEMBER_GET_COMPLAINT_ENUMS = 'MEMBER_GET_COMPLAINT_ENUMS';
export const MEMBER_GET_COMPLAINT_ENUMS_SUCCESS = 'MEMBER_GET_COMPLAINT_ENUMS_SUCCESS';
export const MEMBER_GET_COMPLAINT_ENUMS_FAILURE = 'MEMBER_GET_COMPLAINT_ENUMS_FAILURE';

export const MEMBER_CREATE_COMPLAINT = 'MEMBER_CREATE_COMPLAINT';
export const MEMBER_CREATE_COMPLAINT_SUCCESS = 'MEMBER_CREATE_COMPLAINT_SUCCESS';
export const MEMBER_CREATE_COMPLAINT_FAILURE = 'MEMBER_CREATE_COMPLAINT_FAILURE';

export const MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS = 'MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS';
export const MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS_SUCCESS = 'MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS_SUCCESS';
export const MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE = 'MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE';

export const MEMBER_ADD_COMPLAINT_COMMENT = 'MEMBER_ADD_COMPLAINT_COMMENT';
export const MEMBER_ADD_COMPLAINT_COMMENT_SUCCESS = 'MEMBER_ADD_COMPLAINT_COMMENT_SUCCESS';
export const MEMBER_ADD_COMPLAINT_COMMENT_FAILURE = 'MEMBER_ADD_COMPLAINT_COMMENT_FAILURE';

export const MEMBER_RATE_COMPLAINT = 'MEMBER_RATE_COMPLAINT';
export const MEMBER_RATE_COMPLAINT_SUCCESS = 'MEMBER_RATE_COMPLAINT_SUCCESS';
export const MEMBER_RATE_COMPLAINT_FAILURE = 'MEMBER_RATE_COMPLAINT_FAILURE';
